import { PMEmoji } from "./polymoji_lib"

export const PMEmojiTable: PMEmoji[] =
[
    // smileys & emotion
    // face smiling
    { id: "smileys:grinning", label: "grinning", names: ["grinning"] },
    { id: "smileys:smiley", label: "smiley", names: ["smiley"] },
    { id: "smileys:smile", label: "smile", names: ["smile"] },
    { id: "smileys:grin", label: "grin", names: ["grin"] },
    { id: "smileys:laughing", label: "laughing", names: ["laughing"] },
    { id: "smileys:sweat_smile", label: "sweat smile", names: ["sweat_smile"] },
    { id: "smileys:rofl", label: "rofl", names: ["rofl"] },
    { id: "smileys:joy", label: "joy", names: ["joy"] },
    { id: "smileys:slightly_smiling_face", label: "slightly smiling face", names: ["slightly_smiling_face"] },
    { id: "smileys:upside_down_face", label: "upside down face", names: ["upside_down_face", "upside_down"] },
    { id: "smileys:melting_face", label: "melting face", names: ["melting_face"] },
    { id: "smileys:wink", label: "wink", names: ["wink"] },
    { id: "smileys:blush", label: "blush", names: ["blush"] },
    { id: "smileys:innocent", label: "innocent", names: ["innocent"] },

    // face affection
    { id: "smileys:smiling_face_with_three_hearts", label: "smiling face with three hearts", names: ["smiling_face_with_three_hearts", "smiling_face_with_3_hearts"] },
    { id: "smileys:heart_eyes", label: "heart eyes", names: ["heart_eyes"] },
    { id: "smileys:star_struck", label: "star struck", names: ["star_struck"] },
    { id: "smileys:kissing_heart", label: "kissing heart", names: ["kissing_heart"] },
    { id: "smileys:kissing", label: "kissing", names: ["kissing"] },
    { id: "smileys:smiling_face", label: "smiling face", names: ["smiling_face"] },
    { id: "smileys:kissing_closed_eyes", label: "kissing closed eyes", names: ["kissing_closed_eyes"] },
    { id: "smileys:kissing_smiling_eyes", label: "kissing smiling eyes", names: ["kissing_smiling_eyes"] },
    { id: "smileys:smiling_face_with_tear", label: "smiling face with tear", names: ["smiling_face_with_tear"] },

    // face tongue
    { id: "smileys:yum", label: "yum", names: ["yum"] },
    { id: "smileys:stuck_out_tongue", label: "stuck out tongue", names: ["stuck_out_tongue"] },
    { id: "smileys:stuck_out_tongue_winking_eye", label: "stuck out tongue winking eye", names: ["stuck_out_tongue_winking_eye"] },
    { id: "smileys:zany_face", label: "zany face", names: ["zany_face"] },
    { id: "smileys:stuck_out_tongue_closed_eyes", label: "stuck out tongue closed eyes", names: ["stuck_out_tongue_closed_eyes"] },
    { id: "smileys:money_mouth_face", label: "money mouth face", names: ["money_mouth_face"] },

    // face hand
    { id: "smileys:hugs", label: "hugs", names: ["hugs", "hugging"] },
    { id: "smileys:hand_over_mouth", label: "hand over mouth", names: ["hand_over_mouth"] },
    { id: "smileys:face_with_open_eyes_and_hand_over_mouth", label: "face with open eyes and hand over mouth", names: ["face_with_open_eyes_and_hand_over_mouth"] },
    { id: "smileys:face_with_peeking_eye", label: "face with peeking eye", names: ["face_with_peeking_eye"] },
    { id: "smileys:shushing_face", label: "shushing face", names: ["shushing_face"] },
    { id: "smileys:thinking", label: "thinking", names: ["thinking"] },
    { id: "smileys:saluting_face", label: "saluting face", names: ["saluting_face"] },
    { id: "smileys:zipper_mouth_face", label: "zipper mouth face", names: ["zipper_mouth_face"] },

    // face neutral skeptical
    { id: "smileys:raised_eyebrow", label: "raised eyebrow", names: ["raised_eyebrow"] },
    { id: "smileys:neutral_face", label: "neutral face", names: ["neutral_face"] },
    { id: "smileys:expressionless", label: "expressionless", names: ["expressionless"] },
    { id: "smileys:no_mouth", label: "no mouth", names: ["no_mouth"] },
    { id: "smileys:dotted_line_face", label: "dotted line face", names: ["dotted_line_face"] },
    { id: "smileys:smirk", label: "smirk", names: ["smirk"] },
    { id: "smileys:unamused", label: "unamused", names: ["unamused"] },
    { id: "smileys:rolling_eyes", label: "rolling eyes", names: ["rolling_eyes", "roll_eyes"] },
    { id: "smileys:grimacing", label: "grimacing", names: ["grimacing"] },
    { id: "smileys:lying_face", label: "lying face", names: ["lying_face"] },
    { id: "smileys:shaking_face", label: "shaking face", names: ["shaking_face"] },

    // face sleepy
    { id: "smileys:relieved", label: "relieved", names: ["relieved"] },
    { id: "smileys:pensive", label: "pensive", names: ["pensive"] },
    { id: "smileys:sleepy", label: "sleepy", names: ["sleepy"] },
    { id: "smileys:drooling_face", label: "drooling face", names: ["drooling_face"] },
    { id: "smileys:sleeping", label: "sleeping", names: ["sleeping"] },

    // face unwell
    { id: "smileys:mask", label: "mask", names: ["mask"] },
    { id: "smileys:face_with_thermometer", label: "face with thermometer", names: ["face_with_thermometer"] },
    { id: "smileys:face_with_head_bandage", label: "face with head bandage", names: ["face_with_head_bandage"] },
    { id: "smileys:nauseated_face", label: "nauseated face", names: ["nauseated_face"] },
    { id: "smileys:vomiting_face", label: "vomiting face", names: ["vomiting_face"] },
    { id: "smileys:sneezing_face", label: "sneezing face", names: ["sneezing_face"] },
    { id: "smileys:hot_face", label: "hot face", names: ["hot_face"] },
    { id: "smileys:cold_face", label: "cold face", names: ["cold_face"] },
    { id: "smileys:woozy_face", label: "woozy face", names: ["woozy_face"] },
    { id: "smileys:face_with_spiral_eyes", label: "face with spiral eyes", names: ["face_with_spiral_eyes"] },
    { id: "smileys:dizzy_face", label: "dizzy face", names: ["dizzy_face"] },
    { id: "smileys:exploding_head", label: "exploding head", names: ["exploding_head"] },

    // face hat
    { id: "smileys:cowboy_hat_face", label: "cowboy hat face", names: ["cowboy_hat_face", "face_with_cowboy_hat"] },
    { id: "smileys:partying_face", label: "partying face", names: ["partying_face"] },
    { id: "smileys:disguised_face", label: "disguised face", names: ["disguised_face"] },

    // face glasses
    { id: "smileys:sunglasses", label: "sunglasses", names: ["sunglasses"] },
    { id: "smileys:nerd_face", label: "nerd face", names: ["nerd_face", "nerd"] },
    { id: "smileys:monocle_face", label: "monocle face", names: ["monocle_face"] },

    // face concerned
    { id: "smileys:confused", label: "confused", names: ["confused"] },
    { id: "smileys:worried", label: "worried", names: ["worried"] },
    { id: "smileys:frowning_face", label: "frowning face", names: ["frowning_face"] },
    { id: "smileys:slightly_frowning_face", label: "slightly frowning face", names: ["slightly_frowning_face", "slight_frown"] },
    { id: "smileys:face_exhaling", label: "face exhaling", names: ["face_exhaling"] },
    { id: "smileys:frowning", label: "frowning", names: ["frowning"] },
    { id: "smileys:anguished", label: "anguished", names: ["anguished"] },
    { id: "smileys:fearful", label: "fearful", names: ["fearful"] },
    { id: "smileys:cold_sweat", label: "cold sweat", names: ["cold_sweat"] },
    { id: "smileys:sad_relieved", label: "sad relieved", names: ["sad_relieved", "disappointed_relieved"] },
    { id: "smileys:cry", label: "cry", names: ["cry"] },
    { id: "smileys:sob", label: "sob", names: ["sob"] },
    { id: "smileys:pleading", label: "pleading face", names: ["pleading", "pleading_face"] },
    { id: "smileys:holding_back_tears", label: "holding back tears", names: ["holding_back_tears", "really"] },
    { id: "smileys:distorted_face", label: "distorted face", names: ["distorted_face", "distorted"] },

    // face negative
    { id: "smileys:scream", label: "scream", names: ["scream"] },
    { id: "smileys:flushed", label: "flushed", names: ["flushed"] },
    { id: "smileys:rage", label: "rage", names: ["rage"] },
    { id: "smileys:angry", label: "angry", names: ["angry"] },
    { id: "smileys:cursing_face", label: "cursing face", names: ["cursing_face"] },
    { id: "smileys:triumph", label: "triumph", names: ["triumph"] },

    // face costume
    { id: "smileys:smiling_imp", label: "smiling imp", names: ["smiling_imp"] },
    { id: "smileys:imp", label: "imp", names: ["imp"] },
    { id: "smileys:skull", label: "skull", names: ["skull"] },
    { id: "smileys:skull_and_crossbones", label: "skull and crossbones", names: ["skull_and_crossbones", "skull_crossbones"] },
    { id: "smileys:poop", label: "poop", names: ["poop"] },
    { id: "smileys:clown_face", label: "clown face", names: ["clown_face", "clown"] },
    { id: "smileys:ghost", label: "ghost", names: ["ghost"] },
    { id: "smileys:alien", label: "alien", names: ["alien"] },
    { id: "smileys:space_invader", label: "space invader", names: ["space_invader"] },
    { id: "smileys:robot", label: "robot", names: ["robot"] },
    { id: "smileys:ogre", label: "ogre", names: ["ogre"] },
    { id: "smileys:goblin", label: "goblin", names: ["goblin"] },

    // cat faces
    { id: "smileys:cat/grinning_cat", label: "grinning cat", names: ["grinning_cat"] },
    { id: "smileys:cat/grinning_cat_with_smiling_eyes", label: "grinning cat with smiling eyes", names: ["grinning_cat_with_smiling_eyes"] },
    { id: "smileys:cat/cat_with_tears_of_joy", label: "cat with tears of joy", names: ["cat_with_tears_of_joy"] },
    { id: "smileys:cat/heart_eyes_cat", label: "heart eyes cat", names: ["heart_eyes_cat"] },
    { id: "smileys:cat/cat_with_wry_smile", label: "cat with wry smile", names: ["cat_with_wry_smile"] },
    { id: "smileys:cat/kissing_cat", label: "kissing cat", names: ["kissing_cat"] },
    { id: "smileys:cat/weary_cat", label: "weary cat", names: ["weary_cat"] },
    { id: "smileys:cat/crying_cat", label: "crying cat", names: ["crying_cat"] },
    { id: "smileys:cat/pouting_cat", label: "pouting cat", names: ["pouting_cat"] },

    // monkey faces
    { id: "smileys:monkey/see_no_evil", label: "see no evil", names: ["see_no_evil"] },
    { id: "smileys:monkey/hear_no_evil", label: "hear no evil", names: ["hear_no_evil"] },
    { id: "smileys:monkey/speak_no_evil", label: "speak no evil", names: ["speak_no_evil"] },

    // hearts
    { id: "smileys:heart/red_heart", label: "red heart", names: ["red_heart", "heart"] },
    { id: "smileys:heart/orange_heart", label: "orange heart", names: ["orange_heart"] },
    { id: "smileys:heart/yellow_heart", label: "yellow heart", names: ["yellow_heart"] },
    { id: "smileys:heart/green_heart", label: "green heart", names: ["green_heart"] },
    { id: "smileys:heart/blue_heart", label: "blue heart", names: ["blue_heart"] },
    { id: "smileys:heart/purple_heart", label: "purple heart", names: ["purple_heart"] },
    { id: "smileys:heart/black_heart", label: "black heart", names: ["black_heart"] },
    { id: "smileys:heart/white_heart", label: "white heart", names: ["white_heart"] },
    { id: "smileys:heart/brown_heart", label: "brown heart", names: ["brown_heart"] },
    { id: "smileys:heart/broken_heart", label: "broken heart", names: ["broken_heart"] },
    { id: "smileys:heart/heart_on_fire", label: "heart on fire", names: ["heart_on_fire"] },
    { id: "smileys:heart/mending_heart", label: "mending heart", names: ["mending_heart"] },
    { id: "smileys:heart/two_hearts", label: "two hearts", names: ["two_hearts"] },
    { id: "smileys:heart/sparkling_heart", label: "sparkling heart", names: ["sparkling_heart"] },
    { id: "smileys:heart/growing_heart", label: "growing heart", names: ["growing_heart"] },
    { id: "smileys:heart/beating_heart", label: "beating heart", names: ["beating_heart"] },
    { id: "smileys:heart/revolving_hearts", label: "revolving hearts", names: ["revolving_hearts"] },
    { id: "smileys:heart/cupid_heart", label: "cupid heart", names: ["cupid_heart", "cupid"] },
    { id: "smileys:heart/heart_with_ribbon", label: "heart with ribbon", names: ["heart_with_ribbon"] },
    { id: "smileys:heart/heart_decoration", label: "heart decoration", names: ["heart_decoration"] },

    // emotions
    { id: "smileys:sparkles", label: "sparkles", names: ["sparkles"] },
    { id: "smileys:collision", label: "collision", names: ["collision", "boom"] },
    { id: "smileys:dizzy", label: "dizzy", names: ["dizzy"] },
    { id: "smileys:sweat_drops", label: "sweat drops", names: ["sweat_drops"] },
    { id: "smileys:dash", label: "dash", names: ["dash"] },
    { id: "smileys:bomb", label: "bomb", names: ["bomb"] },
    { id: "smileys:speech_balloon", label: "speech balloon", names: ["speech_balloon"] },
    { id: "smileys:thought_balloon", label: "thought balloon", names: ["thought_balloon"] },
    { id: "smileys:hundred", label: "hundred", names: ["hundred", "100"] },
    { id: "smileys:light_bulb", label: "light bulb", names: ["light_bulb"] },
    { id: "smileys:zzz", label: "zzz", names: ["zzz"] },
    { id: "smileys:anger_symbol", label: "anger symbol", names: ["anger_symbol", "anger"] },
    { id: "smileys:plain_sad", label: "plain sad", names: ["plain_sad"] },
    { id: "smileys:plain_happy", label: "plain happy", names: ["plain_happy"] },
    { id: "smileys:heart/card_suit", label: "card suit", names: ["card_suit"] },
    { id: "smileys:heart/card_suit_red", label: "card suit red", names: ["card_suit_red"] },
    { id: "smileys:speaking_head", label: "speaking head", names: ["speaking_head", "speaking_head_in_silhouette"] },
    { id: "smileys:face_in_clouds", label: "face in clouds", names: ["face_in_clouds"] },
    { id: "smileys:head_shaking_horizontally", label: "head shaking horizontally", names: ["head_shaking_horizontally"] },
    { id: "smileys:head_shaking_vertically", label: "head shaking vertically", names: ["head_shaking_vertically"] },
    { id: "smileys:face_with_bags_under_eyes", label: "face with bags under eyes", names: ["face_with_bags_under_eyes"] },
    { id: "smileys:face_with_diagonal_mouth", label: "face with diagonal mouth", names: ["face_with_diagonal_mouth"] },
    { id: "smileys:face_with_open_mouth", label: "face with open mouth", names: ["face_with_open_mouth"] },
    { id: "smileys:hushed_face", label: "hushed face", names: ["hushed_face"] },
    { id: "smileys:astonished_face", label: "astonished face", names: ["astonished_face"] },
    { id: "smileys:confounded_face", label: "confounded face", names: ["confounded_face"] },
    { id: "smileys:persevering_face", label: "persevering face", names: ["persevering_face"] },
    { id: "smileys:disappointed_face", label: "disappointed face", names: ["disappointed_face"] },
    { id: "smileys:downcast_face_with_sweat", label: "downcast face with sweat", names: ["downcast_face_with_sweat"] },
    { id: "smileys:weary_face", label: "weary face", names: ["weary_face"] },
    { id: "smileys:tired_face", label: "tired face", names: ["tired_face"] },
    { id: "smileys:yawning_face", label: "yawning face", names: ["yawning_face"] },
    { id: "smileys:heart/pink", label: "pink heart", names: ["heart_pink", "pink_heart"] },
    { id: "smileys:heart/light_blue", label: "light blue heart", names: ["heart_light_blue", "light_blue_heart"] },
    { id: "smileys:heart/grey", label: "grey heart", names: ["heart_grey", "grey_heart"] },
    { id: "smileys:eye_in_speech_bubble", label: "eye in speech bubble", names: ["eye_in_speech_bubble"] },
    { id: "smileys:right_anger_bubble", label: "right anger bubble", names: ["right_anger_bubble"] },
    
    // people & body
    // hand fingers open
    { id: "people:hand/wave", label: "wave", names: ["wave", "waving", "waving_hand"] },
    { id: "people:hand/raised_back_of_hand", label: "raised back of hand", names: ["raised_back_of_hand"] },
    { id: "people:hand/raised_hand", label: "raised hand", names: ["raised_hand"] },
    { id: "people:hand/vulcan_salute", label: "vulcan salute", names: ["vulcan_salute"] },
    { id: "people:hand/rightwards_hand", label: "rightwards hand", names: ["rightwards_hand"] },
    { id: "people:hand/leftwards_hand", label: "leftwards hand", names: ["leftwards_hand"] },
    { id: "people:hand/palm_down_hand", label: "palm down hand", names: ["palm_down_hand"] },
    { id: "people:hand/palm_up_hand", label: "palm up hand", names: ["palm_up_hand"] },

    // hand fingers partial
    { id: "people:hand/ok_hand", label: "ok hand", names: ["ok_hand"] },
    { id: "people:hand/pinched_fingers", label: "pinched fingers", names: ["pinched_fingers"] },
    { id: "people:hand/pinching_hand", label: "pinching hand", names: ["pinching_hand"] },
    { id: "people:hand/v", label: "v", names: ["victory"] },
    { id: "people:hand/crossed_fingers", label: "crossed fingers", names: ["crossed_fingers"] },
    { id: "people:hand/love_you_gesture", label: "love you gesture", names: ["love_you_gesture"] },
    { id: "people:hand/the_horns", label: "the horns", names: ["the_horns"] },
    { id: "people:hand/call_me_hand", label: "call me hand", names: ["call_me_hand"] },

    // hand single finger
    { id: "people:hand/point_left", label: "point left", names: ["point_left"] },
    { id: "people:hand/point_right", label: "point right", names: ["point_right"] },
    { id: "people:hand/point_up_2", label: "point up 2", names: ["point_up_2", "point_up"] },
    { id: "people:hand/middle_finger", label: "middle finger", names: ["middle_finger"] },
    { id: "people:hand/point_down", label: "point down", names: ["point_down"] },

    // hand fingers closed
    { id: "people:hand/thumbsup", label: "+1", names: ["+1", "thumbsup", "thumbs_up"] },
    { id: "people:hand/thumbsdown", label: "-1", names: ["-1", "thumbsdown", "thumbs_down"] },
    { id: "people:hand/fist_raised", label: "fist raised", names: ["fist_raised", "fist", "raised_fist"] },
    { id: "people:hand/fist_oncoming", label: "fist oncoming", names: ["fist_oncoming", "facepunch", "punch"] },
    { id: "people:hand/fist_left", label: "fist left", names: ["fist_left"] },
    { id: "people:hand/fist_right", label: "fist right", names: ["fist_right"] },

    // hands
    { id: "people:hand/clap", label: "clap", names: ["clap"] },
    { id: "people:hand/raised_hands", label: "raised hands", names: ["raised_hands"] },
    { id: "people:hand/open_hands", label: "open hands", names: ["open_hands"] },
    { id: "people:hand/palms_up_together", label: "palms up together", names: ["palms_up_together"] },
    { id: "people:hand/handshake", label: "handshake", names: ["handshake"] },
    { id: "people:hand/pray", label: "pray", names: ["pray"] },

    // hand prop
    { id: "people:hand/writing_hand", label: "writing hand", names: ["writing_hand"] },
    { id: "people:hand/nail_care", label: "nail care", names: ["nail_care"] },
    { id: "people:hand/selfie", label: "selfie", names: ["selfie"] },

    // body parts
    { id: "people:body/muscle", label: "muscle", names: ["muscle"] },
    { id: "people:body/ear", label: "ear", names: ["ear"] },
    { id: "people:body/nose", label: "nose", names: ["nose"] },
    { id: "people:body/brain", label: "brain", names: ["brain"] },
    { id: "people:body/anatomical_heart", label: "anatomical heart", names: ["anatomical_heart"] },
    { id: "people:body/lungs", label: "lungs", names: ["lungs"] },
    { id: "people:body/tooth", label: "tooth", names: ["tooth"] },
    { id: "people:body/bone", label: "bone", names: ["bone"] },
    { id: "people:body/eyes", label: "eyes", names: ["eyes"] },
    { id: "people:body/tongue", label: "tongue", names: ["tongue"] },
    { id: "people:body/lips", label: "lips", names: ["lips"] },

    // people
    { id: "people:bust_in_silhouette", label: "bust in silhouette", names: ["bust_in_silhouette"] },
    { id: "people:busts_in_silhouette", label: "busts in silhouette", names: ["busts_in_silhouette"] },
    { id: "people:boy", label: "boy", names: ["boy"] },
    { id: "people:girl", label: "girl", names: ["girl"] },
    { id: "people:man", label: "man", names: ["man"] },
    { id: "people:woman", label: "woman", names: ["woman"] },
    { id: "people:older_man", label: "older man", names: ["older_man"] },
    { id: "people:older_woman", label: "older woman", names: ["older_woman"] },
    { id: "people:person", label: "person", names: ["person"] },
    { id: "people:man_with_turban", label: "man with turban", names: ["man_with_turban"] },
    { id: "people:person_with_blond_hair", label: "person with blond hair", names: ["person_with_blond_hair", "blond_haired_person"] },
    { id: "people:prince", label: "prince", names: ["prince"] },
    { id: "people:bride_with_veil", label: "bride with veil", names: ["bride_with_veil"] },
    { id: "people:man_in_tuxedo", label: "man in tuxedo", names: ["man_in_tuxedo"] },
    { id: "people:princess", label: "princess", names: ["princess"] },
    { id: "people:man_with_gua_pi_mao", label: "man with gua pi mao", names: ["man_with_gua_pi_mao", "man_with_chinese_cap"] },
    { id: "people:woman_with_bunny_ears", label: "woman with bunny ears", names: ["woman_with_bunny_ears", "dancers"] },
    { id: "people:family", label: "family", names: ["family"] },
    { id: "people:kiss_mark", label: "kiss mark", names: ["kiss_mark"] },
    { id: "people:love_letter", label: "love letter", names: ["love_letter"] },
    { id: "people:kiss", label: "kiss", names: ["kiss", "couplekiss"] },
    { id: "people:couple_with_heart", label: "couple with heart", names: ["couple_with_heart"] },
    { id: "people:man_and_woman_holding_hands", label: "man and woman holding hands", names: ["man_and_woman_holding_hands", "couple"] },
    { id: "people:two_men_holding_hands", label: "two men holding hands", names: ["two_men_holding_hands", "men_holding_hands"] },
    { id: "people:two_women_holding_hands", label: "two women holding hands", names: ["two_women_holding_hands", "women_holding_hands"] },
    { id: "people:hand/with_fingers_splayed", label: "hand with fingers splayed", names: ["hand_with_fingers_splayed"] },
    { id: "people:hand/leftwards_pushing_hand", label: "leftwards pushing hand", names: ["hand_leftwards_pushing_hand", "leftwards_pushing_hand"] },
    { id: "people:hand/rightwards_pushing_hand", label: "rightwards pushing hand", names: ["hand_rightwards_pushing_hand", "rightwards_pushing_hand"] },
    { id: "people:hand/victory_hand", label: "victory hand", names: ["hand_victory_hand", "victory_hand"] },
    { id: "people:hand/with_index_finger_and_thumb_crossed", label: "hand with index finger and thumb crossed", names: ["hand_with_index_finger_and_thumb_crossed"] },
    { id: "people:hand/index_pointing_up", label: "index pointing up", names: ["hand_index_pointing_up", "index_pointing_up"] },
    { id: "people:hand/index_pointing_at_the_viewer", label: "index pointing at the viewer", names: ["hand_index_pointing_at_the_viewer", "index_pointing_at_the_viewer"] },
    { id: "people:hand/heart_hands", label: "heart hands", names: ["hand_heart_hands", "heart_hands"] },
    { id: "people:body/mechanical_arm", label: "mechanical arm", names: ["body_mechanical_arm", "mechanical_arm"] },
    { id: "people:body/mechanical_leg", label: "mechanical leg", names: ["body_mechanical_leg", "mechanical_leg"] },
    { id: "people:body/leg", label: "leg", names: ["body_leg", "leg"] },
    { id: "people:body/foot", label: "foot", names: ["body_foot", "foot"] },
    { id: "people:body/ear_with_hearing_aid", label: "ear with hearing aid", names: ["body_ear_with_hearing_aid", "ear_with_hearing_aid"] },
    { id: "people:body/eye", label: "eye", names: ["body_eye", "eye"] },
    { id: "people:body/biting_lip", label: "biting lip", names: ["body_biting_lip", "biting_lip"] },
    { id: "people:person/baby", label: "baby", names: ["person_baby", "baby"] },
    { id: "people:person/child", label: "child", names: ["person_child", "child"] },
    { id: "people:person/person_beard", label: "person: beard", names: ["person_person_beard", "person_beard"] },
    { id: "people:man_beard/man", label: "man: beard", names: ["man_beard_man", "man_beard"] },
    { id: "people:woman_beard/woman", label: "woman: beard", names: ["woman_beard_woman", "woman_beard"] },
    { id: "people:woman_blond_hair/woman", label: "woman: blond hair", names: ["woman_blond_hair_woman", "woman_blond_hair"] },
    { id: "people:man_blond_hair/man", label: "man: blond hair", names: ["man_blond_hair_man", "man_blond_hair"] },
    { id: "people:person/older_person", label: "older person", names: ["person_older_person", "older_person"] },

    // person gestures
    { id: "people:gesture/frowning", label: "person frowning", names: ["gesture_frowning", "person_frowning"] },
    { id: "people:man_frowning/man", label: "man frowning", names: ["man_frowning_man", "man_frowning"] },
    { id: "people:woman_frowning/woman", label: "woman frowning", names: ["woman_frowning_woman", "woman_frowning"] },
    { id: "people:gesture/pouting", label: "person pouting", names: ["gesture_pouting", "person_pouting"] },
    { id: "people:man_pouting/man", label: "man pouting", names: ["man_pouting_man", "man_pouting"] },
    { id: "people:woman_pouting/woman", label: "woman pouting", names: ["woman_pouting_woman", "woman_pouting"] },
    { id: "people:gesture/gesturing_no", label: "person gesturing NO", names: ["gesture_gesturing_no", "person_gesturing_no"] },
    { id: "people:man_gesturing_no/man", label: "man gesturing NO", names: ["man_gesturing_no_man", "man_gesturing_no"] },
    { id: "people:woman_gesturing_no/woman", label: "woman gesturing NO", names: ["woman_gesturing_no_woman", "woman_gesturing_no"] },
    { id: "people:gesture/gesturing_ok", label: "person gesturing OK", names: ["gesture_gesturing_ok", "person_gesturing_ok"] },
    { id: "people:man_gesturing_ok/man", label: "man gesturing OK", names: ["man_gesturing_ok_man", "man_gesturing_ok"] },
    { id: "people:woman_gesturing_ok/woman", label: "woman gesturing OK", names: ["woman_gesturing_ok_woman", "woman_gesturing_ok"] },
    { id: "people:gesture/tipping_hand", label: "person tipping hand", names: ["gesture_tipping_hand", "person_tipping_hand"] },
    { id: "people:man_tipping_hand/man", label: "man tipping hand", names: ["man_tipping_hand_man", "man_tipping_hand"] },
    { id: "people:woman_tipping_hand/woman", label: "woman tipping hand", names: ["woman_tipping_hand_woman", "woman_tipping_hand"] },
    { id: "people:gesture/raising_hand", label: "person raising hand", names: ["gesture_raising_hand", "person_raising_hand"] },
    { id: "people:man_raising_hand/man", label: "man raising hand", names: ["man_raising_hand_man", "man_raising_hand"] },
    { id: "people:woman_raising_hand/woman", label: "woman raising hand", names: ["woman_raising_hand_woman", "woman_raising_hand"] },
    { id: "people:gesture/deaf_person", label: "deaf person", names: ["gesture_deaf_person", "deaf_person"] },
    { id: "people:deaf/man", label: "deaf man", names: ["deaf_man"] },
    { id: "people:deaf/woman", label: "deaf woman", names: ["deaf_woman"] },
    { id: "people:gesture/bowing", label: "person bowing", names: ["gesture_bowing", "person_bowing"] },
    { id: "people:man_bowing/man", label: "man bowing", names: ["man_bowing_man", "man_bowing"] },
    { id: "people:woman_bowing/woman", label: "woman bowing", names: ["woman_bowing_woman", "woman_bowing"] },
    { id: "people:gesture/facepalming", label: "person facepalming", names: ["gesture_facepalming", "person_facepalming"] },
    { id: "people:man_facepalming/man", label: "man facepalming", names: ["man_facepalming_man", "man_facepalming"] },
    { id: "people:woman_facepalming/woman", label: "woman facepalming", names: ["woman_facepalming_woman", "woman_facepalming"] },
    { id: "people:gesture/shrugging", label: "person shrugging", names: ["gesture_shrugging", "person_shrugging"] },
    { id: "people:man_shrugging/man", label: "man shrugging", names: ["man_shrugging_man", "man_shrugging"] },
    { id: "people:woman_shrugging/woman", label: "woman shrugging", names: ["woman_shrugging_woman", "woman_shrugging"] },

    // person roles
    { id: "people:health_worker", label: "health worker", names: ["health_worker"] },
    { id: "people:health_worker/man", label: "man health worker", names: ["health_worker_man", "man_health_worker"] },
    { id: "people:health_worker/woman", label: "woman health worker", names: ["health_worker_woman", "woman_health_worker"] },
    { id: "people:student", label: "student", names: ["student"] },
    { id: "people:student/man", label: "man student", names: ["student_man", "man_student"] },
    { id: "people:student/woman", label: "woman student", names: ["student_woman", "woman_student"] },
    { id: "people:teacher", label: "teacher", names: ["teacher"] },
    { id: "people:teacher/man", label: "man teacher", names: ["teacher_man", "man_teacher"] },
    { id: "people:teacher/woman", label: "woman teacher", names: ["teacher_woman", "woman_teacher"] },
    { id: "people:judge", label: "judge", names: ["judge"] },
    { id: "people:judge/man", label: "man judge", names: ["judge_man", "man_judge"] },
    { id: "people:judge/woman", label: "woman judge", names: ["judge_woman", "woman_judge"] },
    { id: "people:farmer", label: "farmer", names: ["farmer"] },
    { id: "people:farmer/man", label: "man farmer", names: ["farmer_man", "man_farmer"] },
    { id: "people:farmer/woman", label: "woman farmer", names: ["farmer_woman", "woman_farmer"] },
    { id: "people:cook", label: "cook", names: ["cook"] },
    { id: "people:cook/man", label: "man cook", names: ["cook_man", "man_cook"] },
    { id: "people:cook/woman", label: "woman cook", names: ["cook_woman", "woman_cook"] },
    { id: "people:mechanic", label: "mechanic", names: ["mechanic"] },
    { id: "people:mechanic/man", label: "man mechanic", names: ["mechanic_man", "man_mechanic"] },
    { id: "people:mechanic/woman", label: "woman mechanic", names: ["mechanic_woman", "woman_mechanic"] },
    { id: "people:factory_worker", label: "factory worker", names: ["factory_worker"] },
    { id: "people:factory_worker/man", label: "man factory worker", names: ["factory_worker_man", "man_factory_worker"] },
    { id: "people:factory_worker/woman", label: "woman factory worker", names: ["factory_worker_woman", "woman_factory_worker"] },
    { id: "people:office_worker", label: "office worker", names: ["office_worker"] },
    { id: "people:office_worker/man", label: "man office worker", names: ["office_worker_man", "man_office_worker"] },
    { id: "people:office_worker/woman", label: "woman office worker", names: ["office_worker_woman", "woman_office_worker"] },
    { id: "people:scientist", label: "scientist", names: ["scientist"] },
    { id: "people:scientist/man", label: "man scientist", names: ["scientist_man", "man_scientist"] },
    { id: "people:scientist/woman", label: "woman scientist", names: ["scientist_woman", "woman_scientist"] },
    { id: "people:technologist", label: "technologist", names: ["technologist"] },
    { id: "people:technologist/man", label: "man technologist", names: ["technologist_man", "man_technologist"] },
    { id: "people:technologist/woman", label: "woman technologist", names: ["technologist_woman", "woman_technologist"] },
    { id: "people:singer", label: "singer", names: ["singer"] },
    { id: "people:singer/man", label: "man singer", names: ["singer_man", "man_singer"] },
    { id: "people:singer/woman", label: "woman singer", names: ["singer_woman", "woman_singer"] },
    { id: "people:artist", label: "artist", names: ["artist"] },
    { id: "people:artist/man", label: "man artist", names: ["artist_man", "man_artist"] },
    { id: "people:artist/woman", label: "woman artist", names: ["artist_woman", "woman_artist"] },
    { id: "people:pilot", label: "pilot", names: ["pilot"] },
    { id: "people:pilot/man", label: "man pilot", names: ["pilot_man", "man_pilot"] },
    { id: "people:pilot/woman", label: "woman pilot", names: ["pilot_woman", "woman_pilot"] },
    { id: "people:astronaut", label: "astronaut", names: ["astronaut"] },
    { id: "people:astronaut/man", label: "man astronaut", names: ["astronaut_man", "man_astronaut"] },
    { id: "people:astronaut/woman", label: "woman astronaut", names: ["astronaut_woman", "woman_astronaut"] },
    { id: "people:firefighter", label: "firefighter", names: ["firefighter"] },
    { id: "people:firefighter/man", label: "man firefighter", names: ["firefighter_man", "man_firefighter"] },
    { id: "people:firefighter/woman", label: "woman firefighter", names: ["firefighter_woman", "woman_firefighter"] },
    { id: "people:role/police_officer", label: "police officer", names: ["role_police_officer", "police_officer"] },
    { id: "people:man_police_officer/man", label: "man police officer", names: ["man_police_officer_man", "man_police_officer"] },
    { id: "people:woman_police_officer/woman", label: "woman police officer", names: ["woman_police_officer_woman", "woman_police_officer"] },
    { id: "people:role/detective", label: "detective", names: ["role_detective", "detective"] },
    { id: "people:man_detective/man", label: "man detective", names: ["man_detective_man", "man_detective"] },
    { id: "people:woman_detective/woman", label: "woman detective", names: ["woman_detective_woman", "woman_detective"] },
    { id: "people:role/guard", label: "guard", names: ["role_guard", "guard"] },
    { id: "people:man_guard/man", label: "man guard", names: ["man_guard_man", "man_guard"] },
    { id: "people:woman_guard/woman", label: "woman guard", names: ["woman_guard_woman", "woman_guard"] },
    { id: "people:role/ninja", label: "ninja", names: ["role_ninja", "ninja"] },
    { id: "people:role/construction_worker", label: "construction worker", names: ["role_construction_worker", "construction_worker"] },
    { id: "people:man_construction_worker/man", label: "man construction worker", names: ["man_construction_worker_man", "man_construction_worker"] },
    { id: "people:woman_construction_worker/woman", label: "woman construction worker", names: ["woman_construction_worker_woman", "woman_construction_worker"] },
    { id: "people:role/with_crown", label: "person with crown", names: ["role_with_crown", "person_with_crown"] },
    { id: "people:man_wearing_turban/man", label: "man wearing turban", names: ["man_wearing_turban_man", "man_wearing_turban"] },
    { id: "people:woman_wearing_turban/woman", label: "woman wearing turban", names: ["woman_wearing_turban_woman", "woman_wearing_turban"] },
    { id: "people:role/woman_with_headscarf", label: "woman with headscarf", names: ["role_woman_with_headscarf", "woman_with_headscarf"] },
    { id: "people:man_in_tuxedo/man", label: "man in tuxedo", names: ["man_tuxedo_man"] },
    { id: "people:woman_in_tuxedo/woman", label: "woman in tuxedo", names: ["woman_in_tuxedo_woman", "woman_in_tuxedo"] },
    { id: "people:man_with_veil/man", label: "man with veil", names: ["man_with_veil_man", "man_with_veil"] },
    { id: "people:woman_with_veil/woman", label: "woman with veil", names: ["woman_with_veil_woman", "woman_with_veil"] },
    { id: "people:role/pregnant_woman", label: "pregnant woman", names: ["role_pregnant_woman", "pregnant_woman"] },
    { id: "people:role/pregnant_man", label: "pregnant man", names: ["role_pregnant_man", "pregnant_man"] },
    { id: "people:role/pregnant_person", label: "pregnant person", names: ["role_pregnant_person", "pregnant_person"] },
    { id: "people:role/breast_feeding", label: "breast-feeding", names: ["role_breast_feeding", "breast_feeding"] },
    { id: "people:feeding_baby/woman", label: "woman feeding baby", names: ["feeding_baby_woman", "woman_feeding_baby"] },
    { id: "people:feeding_baby/man", label: "man feeding baby", names: ["feeding_baby_man", "man_feeding_baby"] },
    { id: "people:feeding_baby", label: "person feeding baby", names: ["feeding_baby", "person_feeding_baby"] },

    // person fantasy
    { id: "people:fantasy/baby_angel", label: "baby angel", names: ["fantasy_baby_angel", "baby_angel"] },
    { id: "people:fantasy/mrs_claus", label: "Mrs. Claus", names: ["fantasy_mrs_claus", "mrs_claus"] },
    { id: "people:mx_claus", label: "Mx Claus", names: ["mx_claus"] },
    { id: "people:fantasy/superhero", label: "superhero", names: ["fantasy_superhero", "superhero"] },
    { id: "people:man_superhero/man", label: "man superhero", names: ["man_superhero_man", "man_superhero"] },
    { id: "people:woman_superhero/woman", label: "woman superhero", names: ["woman_superhero_woman", "woman_superhero"] },
    { id: "people:fantasy/supervillain", label: "supervillain", names: ["fantasy_supervillain", "supervillain"] },
    { id: "people:man_supervillain/man", label: "man supervillain", names: ["man_supervillain_man", "man_supervillain"] },
    { id: "people:woman_supervillain/woman", label: "woman supervillain", names: ["woman_supervillain_woman", "woman_supervillain"] },
    { id: "people:fantasy/mage", label: "mage", names: ["fantasy_mage", "mage"] },
    { id: "people:man_mage/man", label: "man mage", names: ["man_mage_man", "man_mage"] },
    { id: "people:woman_mage/woman", label: "woman mage", names: ["woman_mage_woman", "woman_mage"] },
    { id: "people:fantasy/fairy", label: "fairy", names: ["fantasy_fairy", "fairy"] },
    { id: "people:man_fairy/man", label: "man fairy", names: ["man_fairy_man", "man_fairy"] },
    { id: "people:woman_fairy/woman", label: "woman fairy", names: ["woman_fairy_woman", "woman_fairy"] },
    { id: "people:fantasy/vampire", label: "vampire", names: ["fantasy_vampire", "vampire"] },
    { id: "people:man_vampire/man", label: "man vampire", names: ["man_vampire_man", "man_vampire"] },
    { id: "people:woman_vampire/woman", label: "woman vampire", names: ["woman_vampire_woman", "woman_vampire"] },
    { id: "people:fantasy/merperson", label: "merperson", names: ["fantasy_merperson", "merperson"] },
    { id: "people:mer/man", label: "merman", names: ["mer_man", "merman"] },
    { id: "people:mermaid/woman", label: "mermaid", names: ["mermaid_woman", "mermaid"] },
    { id: "people:fantasy/elf", label: "elf", names: ["fantasy_elf", "elf"] },
    { id: "people:man_elf/man", label: "man elf", names: ["man_elf_man", "man_elf"] },
    { id: "people:woman_elf/woman", label: "woman elf", names: ["woman_elf_woman", "woman_elf"] },
    { id: "people:fantasy/genie", label: "genie", names: ["fantasy_genie", "genie"] },
    { id: "people:man_genie/man", label: "man genie", names: ["man_genie_man", "man_genie"] },
    { id: "people:woman_genie/woman", label: "woman genie", names: ["woman_genie_woman", "woman_genie"] },
    { id: "people:fantasy/zombie", label: "zombie", names: ["fantasy_zombie", "zombie"] },
    { id: "people:man_zombie/man", label: "man zombie", names: ["man_zombie_man", "man_zombie"] },
    { id: "people:woman_zombie/woman", label: "woman zombie", names: ["woman_zombie_woman", "woman_zombie"] },

    // person activities
    { id: "people:activity/getting_massage", label: "person getting massage", names: ["activity_getting_massage", "person_getting_massage"] },
    { id: "people:man_getting_massage/man", label: "man getting massage", names: ["man_getting_massage_man", "man_getting_massage"] },
    { id: "people:woman_getting_massage/woman", label: "woman getting massage", names: ["woman_getting_massage_woman", "woman_getting_massage"] },
    { id: "people:activity/getting_haircut", label: "person getting haircut", names: ["activity_getting_haircut", "person_getting_haircut"] },
    { id: "people:man_getting_haircut/man", label: "man getting haircut", names: ["man_getting_haircut_man", "man_getting_haircut"] },
    { id: "people:woman_getting_haircut/woman", label: "woman getting haircut", names: ["woman_getting_haircut_woman", "woman_getting_haircut"] },
    { id: "people:man_walking/man", label: "man walking", names: ["man_walking_man", "man_walking"] },
    { id: "people:woman_walking/woman", label: "woman walking", names: ["woman_walking_woman", "woman_walking"] },
    { id: "people:person_walking_facing_right", label: "person walking facing right", names: ["person_walking_facing_right"] },
    { id: "people:woman_walking_facing_right", label: "woman walking facing right", names: ["woman_walking_facing_right"] },
    { id: "people:man_walking_facing_right", label: "man walking facing right", names: ["man_walking_facing_right"] },
    { id: "people:activity/standing", label: "person standing", names: ["activity_standing", "person_standing"] },
    { id: "people:man_standing/man", label: "man standing", names: ["man_standing_man", "man_standing"] },
    { id: "people:woman_standing/woman", label: "woman standing", names: ["woman_standing_woman", "woman_standing"] },
    { id: "people:activity/kneeling", label: "person kneeling", names: ["activity_kneeling", "person_kneeling"] },
    { id: "people:man_kneeling/man", label: "man kneeling", names: ["man_kneeling_man", "man_kneeling"] },
    { id: "people:woman_kneeling/woman", label: "woman kneeling", names: ["woman_kneeling_woman", "woman_kneeling"] },
    { id: "people:person_kneeling_facing_right", label: "person kneeling facing right", names: ["person_kneeling_facing_right"] },
    { id: "people:woman_kneeling_facing_right", label: "woman kneeling facing right", names: ["woman_kneeling_facing_right"] },
    { id: "people:man_kneeling_facing_right", label: "man kneeling facing right", names: ["man_kneeling_facing_right"] },
    { id: "people:with_white_cane", label: "person with white cane", names: ["with_white_cane", "person_with_white_cane"] },
    { id: "people:with_white_cane_facing_right", label: "person with white cane facing right", names: ["with_white_cane_facing_right", "person_with_white_cane_facing_right"] },
    { id: "people:with_white_cane/man", label: "man with white cane", names: ["with_white_cane_man", "man_with_white_cane"] },
    { id: "people:with_white_cane_facing_right/man", label: "man with white cane facing right", names: ["with_white_cane_facing_right_man", "man_with_white_cane_facing_right"] },
    { id: "people:with_white_cane/woman", label: "woman with white cane", names: ["with_white_cane_woman", "woman_with_white_cane"] },
    { id: "people:with_white_cane_facing_right/woman", label: "woman with white cane facing right", names: ["with_white_cane_facing_right_woman", "woman_with_white_cane_facing_right"] },
    { id: "people:in_motorized_wheelchair", label: "person in motorized wheelchair", names: ["in_motorized_wheelchair", "person_in_motorized_wheelchair"] },
    { id: "people:in_motorized_wheelchair_facing_right", label: "person in motorized wheelchair facing right", names: ["in_motorized_wheelchair_facing_right", "person_in_motorized_wheelchair_facing_right"] },
    { id: "people:in_motorized_wheelchair/man", label: "man in motorized wheelchair", names: ["in_motorized_wheelchair_man", "man_in_motorized_wheelchair"] },
    { id: "people:in_motorized_wheelchair_facing_right/man", label: "man in motorized wheelchair facing right", names: ["in_motorized_wheelchair_facing_right_man", "man_in_motorized_wheelchair_facing_right"] },
    { id: "people:in_motorized_wheelchair/woman", label: "woman in motorized wheelchair", names: ["in_motorized_wheelchair_woman", "woman_in_motorized_wheelchair"] },
    { id: "people:in_motorized_wheelchair_facing_right/woman", label: "woman in motorized wheelchair facing right", names: ["in_motorized_wheelchair_facing_right_woman", "woman_in_motorized_wheelchair_facing_right"] },
    { id: "people:in_manual_wheelchair", label: "person in manual wheelchair", names: ["in_manual_wheelchair", "person_in_manual_wheelchair"] },
    { id: "people:in_manual_wheelchair_facing_right", label: "person in manual wheelchair facing right", names: ["in_manual_wheelchair_facing_right", "person_in_manual_wheelchair_facing_right"] },
    { id: "people:in_manual_wheelchair/man", label: "man in manual wheelchair", names: ["in_manual_wheelchair_man", "man_in_manual_wheelchair"] },
    { id: "people:in_manual_wheelchair_facing_right/man", label: "man in manual wheelchair facing right", names: ["in_manual_wheelchair_facing_right_man", "man_in_manual_wheelchair_facing_right"] },
    { id: "people:in_manual_wheelchair/woman", label: "woman in manual wheelchair", names: ["in_manual_wheelchair_woman", "woman_in_manual_wheelchair"] },
    { id: "people:in_manual_wheelchair_facing_right/woman", label: "woman in manual wheelchair facing right", names: ["in_manual_wheelchair_facing_right_woman", "woman_in_manual_wheelchair_facing_right"] },
    { id: "people:man_running/man", label: "man running", names: ["man_running_man", "man_running"] },
    { id: "people:woman_running/woman", label: "woman running", names: ["woman_running_woman", "woman_running"] },
    { id: "people:person_running_facing_right", label: "person running facing right", names: ["person_running_facing_right"] },
    { id: "people:woman_running_facing_right", label: "woman running facing right", names: ["woman_running_facing_right"] },
    { id: "people:man_running_facing_right", label: "man running facing right", names: ["man_running_facing_right"] },
    { id: "people:activity/woman_dancing", label: "woman dancing", names: ["activity_woman_dancing", "woman_dancing"] },
    { id: "people:activity/man_dancing", label: "man dancing", names: ["activity_man_dancing", "man_dancing"] },
    { id: "people:men_with_bunny_ears/man", label: "men with bunny ears", names: ["men_with_bunny_ears_man", "men_with_bunny_ears"] },
    { id: "people:women_with_bunny_ears/woman", label: "women with bunny ears", names: ["women_with_bunny_ears_woman", "women_with_bunny_ears"] },
    { id: "people:activity/in_steamy_room", label: "person in steamy room", names: ["activity_in_steamy_room", "person_in_steamy_room"] },
    { id: "people:man_in_steamy_room/man", label: "man in steamy room", names: ["man_in_steamy_room_man", "man_in_steamy_room"] },
    { id: "people:woman_in_steamy_room/woman", label: "woman in steamy room", names: ["woman_in_steamy_room_woman", "woman_in_steamy_room"] },
    { id: "people:activity/climbing", label: "person climbing", names: ["activity_climbing", "person_climbing"] },
    { id: "people:man_climbing/man", label: "man climbing", names: ["man_climbing_man", "man_climbing"] },
    { id: "people:woman_climbing/woman", label: "woman climbing", names: ["woman_climbing_woman", "woman_climbing"] },

    // person sports
    { id: "people:sport/fencing", label: "person fencing", names: ["sport_fencing", "person_fencing"] },
    { id: "people:man_golfing/man", label: "man golfing", names: ["man_golfing_man", "man_golfing"] },
    { id: "people:woman_golfing/woman", label: "woman golfing", names: ["woman_golfing_woman", "woman_golfing"] },
    { id: "people:man_surfing/man", label: "man surfing", names: ["man_surfing_man", "man_surfing"] },
    { id: "people:woman_surfing/woman", label: "woman surfing", names: ["woman_surfing_woman", "woman_surfing"] },
    { id: "people:sport/rowing_boat", label: "person rowing boat", names: ["sport_rowing_boat", "person_rowing_boat"] },
    { id: "people:man_rowing_boat/man", label: "man rowing boat", names: ["man_rowing_boat_man", "man_rowing_boat"] },
    { id: "people:woman_rowing_boat/woman", label: "woman rowing boat", names: ["woman_rowing_boat_woman", "woman_rowing_boat"] },
    { id: "people:man_swimming/man", label: "man swimming", names: ["man_swimming_man", "man_swimming"] },
    { id: "people:woman_swimming/woman", label: "woman swimming", names: ["woman_swimming_woman", "woman_swimming"] },
    { id: "people:man_bouncing_ball/man", label: "man bouncing ball", names: ["man_bouncing_ball_man", "man_bouncing_ball"] },
    { id: "people:woman_bouncing_ball/woman", label: "woman bouncing ball", names: ["woman_bouncing_ball_woman", "woman_bouncing_ball"] },
    { id: "people:man_lifting_weights/man", label: "man lifting weights", names: ["man_lifting_weights_man", "man_lifting_weights"] },
    { id: "people:woman_lifting_weights/woman", label: "woman lifting weights", names: ["woman_lifting_weights_woman", "woman_lifting_weights"] },
    { id: "people:man_biking/man", label: "man biking", names: ["man_biking_man", "man_biking"] },
    { id: "people:woman_biking/woman", label: "woman biking", names: ["woman_biking_woman", "woman_biking"] },
    { id: "people:man_mountain_biking/man", label: "man mountain biking", names: ["man_mountain_biking_man", "man_mountain_biking"] },
    { id: "people:woman_mountain_biking/woman", label: "woman mountain biking", names: ["woman_mountain_biking_woman", "woman_mountain_biking"] },
    { id: "people:sport/cartwheeling", label: "person cartwheeling", names: ["sport_cartwheeling", "person_cartwheeling"] },
    { id: "people:man_cartwheeling/man", label: "man cartwheeling", names: ["man_cartwheeling_man", "man_cartwheeling"] },
    { id: "people:woman_cartwheeling/woman", label: "woman cartwheeling", names: ["woman_cartwheeling_woman", "woman_cartwheeling"] },
    { id: "people:sport/people_wrestling", label: "people wrestling", names: ["sport_people_wrestling", "people_wrestling"] },
    { id: "people:men_wrestling/man", label: "men wrestling", names: ["men_wrestling_man", "men_wrestling"] },
    { id: "people:women_wrestling/woman", label: "women wrestling", names: ["women_wrestling_woman", "women_wrestling"] },
    { id: "people:sport/playing_water_polo", label: "person playing water polo", names: ["sport_playing_water_polo", "person_playing_water_polo"] },
    { id: "people:man_playing_water_polo/man", label: "man playing water polo", names: ["man_playing_water_polo_man", "man_playing_water_polo"] },
    { id: "people:woman_playing_water_polo/woman", label: "woman playing water polo", names: ["woman_playing_water_polo_woman", "woman_playing_water_polo"] },
    { id: "people:sport/playing_handball", label: "person playing handball", names: ["sport_playing_handball", "person_playing_handball"] },
    { id: "people:man_playing_handball/man", label: "man playing handball", names: ["man_playing_handball_man", "man_playing_handball"] },
    { id: "people:woman_playing_handball/woman", label: "woman playing handball", names: ["woman_playing_handball_woman", "woman_playing_handball"] },
    { id: "people:sport/juggling", label: "person juggling", names: ["sport_juggling", "person_juggling"] },
    { id: "people:man_juggling/man", label: "man juggling", names: ["man_juggling_man", "man_juggling"] },
    { id: "people:woman_juggling/woman", label: "woman juggling", names: ["woman_juggling_woman", "woman_juggling"] },

    // person resting
    { id: "people:rest/in_lotus_position", label: "person in lotus position", names: ["rest_in_lotus_position", "person_in_lotus_position"] },
    { id: "people:man_in_lotus_position/man", label: "man in lotus position", names: ["man_in_lotus_position_man", "man_in_lotus_position"] },
    { id: "people:woman_in_lotus_position/woman", label: "woman in lotus position", names: ["woman_in_lotus_position_woman", "woman_in_lotus_position"] },

    // family
    { id: "people:people_holding_hands", label: "people holding hands", names: ["people_holding_hands"] },
    { id: "people:kiss_woman_man/woman", label: "kiss: woman, man", names: ["kiss_woman_man_woman", "kiss_woman_man"] },
    { id: "people:kiss_man_man/man", label: "kiss: man, man", names: ["kiss_man_man_man", "kiss_man_man"] },
    { id: "people:kiss_woman_woman/woman", label: "kiss: woman, woman", names: ["kiss_woman_woman_woman", "kiss_woman_woman"] },
    { id: "people:couple_with_heart_woman_man/woman", label: "couple with heart: woman, man", names: ["couple_with_heart_woman_man_woman", "couple_with_heart_woman_man"] },
    { id: "people:couple_with_heart_man_man/man", label: "couple with heart: man, man", names: ["couple_with_heart_man_man_man", "couple_with_heart_man_man"] },
    { id: "people:couple_with_heart_woman_woman/woman", label: "couple with heart: woman, woman", names: ["couple_with_heart_woman_woman_woman", "couple_with_heart_woman_woman"] },
    { id: "people:family/man_woman_boy", label: "family: man, woman, boy", names: ["family_man_woman_boy"] },
    { id: "people:family/man_woman_girl", label: "family: man, woman, girl", names: ["family_man_woman_girl"] },
    { id: "people:family/man_woman_girl_boy", label: "family: man, woman, girl, boy", names: ["family_man_woman_girl_boy"] },
    { id: "people:family/man_woman_boy_boy", label: "family: man, woman, boy, boy", names: ["family_man_woman_boy_boy"] },
    { id: "people:family/man_woman_girl_girl", label: "family: man, woman, girl, girl", names: ["family_man_woman_girl_girl"] },
    { id: "people:family/man_man_boy", label: "family: man, man, boy", names: ["family_man_man_boy"] },
    { id: "people:family/man_man_girl", label: "family: man, man, girl", names: ["family_man_man_girl"] },
    { id: "people:family/man_man_girl_boy", label: "family: man, man, girl, boy", names: ["family_man_man_girl_boy"] },
    { id: "people:family/man_man_boy_boy", label: "family: man, man, boy, boy", names: ["family_man_man_boy_boy"] },
    { id: "people:family/man_man_girl_girl", label: "family: man, man, girl, girl", names: ["family_man_man_girl_girl"] },
    { id: "people:family/woman_woman_boy", label: "family: woman, woman, boy", names: ["family_woman_woman_boy"] },
    { id: "people:family/woman_woman_girl", label: "family: woman, woman, girl", names: ["family_woman_woman_girl"] },
    { id: "people:family/woman_woman_girl_boy", label: "family: woman, woman, girl, boy", names: ["family_woman_woman_girl_boy"] },
    { id: "people:family/woman_woman_boy_boy", label: "family: woman, woman, boy, boy", names: ["family_woman_woman_boy_boy"] },
    { id: "people:family/woman_woman_girl_girl", label: "family: woman, woman, girl, girl", names: ["family_woman_woman_girl_girl"] },
    { id: "people:family/man_boy", label: "family: man, boy", names: ["family_man_boy"] },
    { id: "people:family/man_boy_boy", label: "family: man, boy, boy", names: ["family_man_boy_boy"] },
    { id: "people:family/man_girl", label: "family: man, girl", names: ["family_man_girl"] },
    { id: "people:family/man_girl_boy", label: "family: man, girl, boy", names: ["family_man_girl_boy"] },
    { id: "people:family/man_girl_girl", label: "family: man, girl, girl", names: ["family_man_girl_girl"] },
    { id: "people:family/woman_boy", label: "family: woman, boy", names: ["family_woman_boy"] },
    { id: "people:family/woman_boy_boy", label: "family: woman, boy, boy", names: ["family_woman_boy_boy"] },
    { id: "people:family/woman_girl", label: "family: woman, girl", names: ["family_woman_girl"] },
    { id: "people:family/woman_girl_boy", label: "family: woman, girl, boy", names: ["family_woman_girl_boy"] },
    { id: "people:family/woman_girl_girl", label: "family: woman, girl, girl", names: ["family_woman_girl_girl"] },
    { id: "people:people_hugging", label: "people hugging", names: ["people_hugging"] },
    { id: "people:family/adult_adult_child", label: "family: adult, adult, child", names: ["family_adult_adult_child"] },
    { id: "people:family/adult_adult_child_child", label: "family: adult, adult, child, child", names: ["family_adult_adult_child_child"] },
    { id: "people:family/adult_child", label: "family: adult, child", names: ["family_adult_child"] },
    { id: "people:family/adult_child_child", label: "family: adult, child, child", names: ["family_adult_child_child"] },

    // person symbols
    { id: "people:footprints", label: "footprints", names: ["footprints"] },
    { id: "people:fingerprint", label: "fingerprint", names: ["fingerprint"] },
    
    // animals & nature
    // animal mammals
    { id: "nature:monkey_face", label: "monkey face", names: ["monkey_face"] },
    { id: "nature:monkey", label: "monkey", names: ["monkey"] },
    { id: "nature:gorilla", label: "gorilla", names: ["gorilla"] },
    { id: "nature:orangutan", label: "orangutan", names: ["orangutan"] },
    { id: "nature:dog_face", label: "dog face", names: ["dog_face"] },
    { id: "nature:dog", label: "dog", names: ["dog"] },
    { id: "nature:guide_dog", label: "guide dog", names: ["guide_dog"] },
    { id: "nature:service_dog", label: "service dog", names: ["service_dog"] },
    { id: "nature:poodle", label: "poodle", names: ["poodle"] },
    { id: "nature:wolf", label: "wolf", names: ["wolf"] },
    { id: "nature:fox", label: "fox", names: ["fox"] },
    { id: "nature:raccoon", label: "raccoon", names: ["raccoon"] },
    { id: "nature:cat_face", label: "cat face", names: ["cat_face"] },
    { id: "nature:cat", label: "cat", names: ["cat"] },
    { id: "nature:black_cat", label: "black cat", names: ["black_cat"] },
    { id: "nature:tiger_face", label: "tiger face", names: ["tiger_face"] },
    { id: "nature:tiger", label: "tiger", names: ["tiger"] },
    { id: "nature:leopard", label: "leopard", names: ["leopard"] },
    { id: "nature:horse_face", label: "horse face", names: ["horse_face"] },
    { id: "nature:horse", label: "horse", names: ["horse"] },
    { id: "nature:unicorn", label: "unicorn", names: ["unicorn"] },
    { id: "nature:zebra", label: "zebra", names: ["zebra"] },
    { id: "nature:cow", label: "cow", names: ["cow"] },
    { id: "nature:pig_face", label: "pig face", names: ["pig_face"] },
    { id: "nature:pig", label: "pig", names: ["pig"] },
    { id: "nature:boar", label: "boar", names: ["boar"] },
    { id: "nature:pig_nose", label: "pig nose", names: ["pig_nose"] },
    { id: "nature:ram", label: "ram", names: ["ram"] },
    { id: "nature:sheep", label: "sheep", names: ["sheep"] },
    { id: "nature:goat", label: "goat", names: ["goat"] },
    { id: "nature:dromedary_camel", label: "dromedary camel", names: ["dromedary_camel"] },
    { id: "nature:camel", label: "camel", names: ["camel"] },
    { id: "nature:llama", label: "llama", names: ["llama"] },
    { id: "nature:giraffe", label: "giraffe", names: ["giraffe"] },
    { id: "nature:elephant", label: "elephant", names: ["elephant"] },
    { id: "nature:mammoth", label: "mammoth", names: ["mammoth"] },
    { id: "nature:rhinoceros", label: "rhinoceros", names: ["rhinoceros", "rhino"] },
    { id: "nature:hippopotamus", label: "hippopotamus", names: ["hippopotamus", "hippo"] },
    { id: "nature:mouse_face", label: "mouse face", names: ["mouse_face"] },
    { id: "nature:mouse", label: "mouse", names: ["mouse"] },
    { id: "nature:rat", label: "rat", names: ["rat"] },
    { id: "nature:hamster", label: "hamster", names: ["hamster"] },
    { id: "nature:rabbit_face", label: "rabbit face", names: ["rabbit_face"] },
    { id: "nature:rabbit", label: "rabbit", names: ["rabbit"] },
    { id: "nature:chipmunk", label: "chipmunk", names: ["chipmunk"] },
    { id: "nature:beaver", label: "beaver", names: ["beaver"] },
    { id: "nature:badger", label: "badger", names: ["badger"] },
    { id: "nature:otter", label: "otter", names: ["otter"] },
    { id: "nature:skunk", label: "skunk", names: ["skunk"] },
    { id: "nature:kangaroo", label: "kangaroo", names: ["kangaroo"] },
    { id: "nature:sloth", label: "sloth", names: ["sloth"] },
    { id: "nature:bear", label: "bear", names: ["bear"] },
    { id: "nature:polar_bear", label: "polar bear", names: ["polar_bear"] },
    { id: "nature:koala", label: "koala", names: ["koala"] },
    { id: "nature:panda", label: "panda", names: ["panda", "panda_face"] },
    { id: "nature:paw_prints", label: "paw prints", names: ["paw_prints"] },
    { id: "nature:hedgehog", label: "hedgehog", names: ["hedgehog"] },

    // animal birds
    { id: "nature:turkey", label: "turkey", names: ["turkey"] },
    { id: "nature:chicken", label: "chicken", names: ["chicken"] },
    { id: "nature:rooster", label: "rooster", names: ["rooster"] },
    { id: "nature:hatching_chick", label: "hatching chick", names: ["hatching_chick"] },
    { id: "nature:baby_chick", label: "baby chick", names: ["baby_chick"] },
    { id: "nature:front_facing_baby_chick", label: "front facing baby chick", names: ["front_facing_baby_chick", "hatched_chick"] },
    { id: "nature:bird", label: "bird", names: ["bird"] },
    { id: "nature:penguin", label: "penguin", names: ["penguin"] },
    { id: "nature:dove", label: "dove", names: ["dove"] },
    { id: "nature:eagle", label: "eagle", names: ["eagle"] },
    { id: "nature:duck", label: "duck", names: ["duck"] },
    { id: "nature:swan", label: "swan", names: ["swan"] },
    { id: "nature:owl", label: "owl", names: ["owl"] },
    { id: "nature:dodo", label: "dodo", names: ["dodo"] },
    { id: "nature:feather", label: "feather", names: ["feather"] },
    { id: "nature:flamingo", label: "flamingo", names: ["flamingo"] },
    { id: "nature:peacock", label: "peacock", names: ["peacock"] },

    // animal reptiles
    { id: "nature:crocodile", label: "crocodile", names: ["crocodile"] },
    { id: "nature:turtle", label: "turtle", names: ["turtle"] },
    { id: "nature:lizard", label: "lizard", names: ["lizard"] },
    { id: "nature:snake", label: "snake", names: ["snake"] },
    { id: "nature:dragon_face", label: "dragon face", names: ["dragon_face"] },
    { id: "nature:dragon", label: "dragon", names: ["dragon"] },
    { id: "nature:sauropod", label: "sauropod", names: ["sauropod"] },
    { id: "nature:t_rex", label: "t rex", names: ["t_rex"] },

    // animal amphibians
    { id: "nature:frog", label: "frog", names: ["frog"] },

    // animal marine
    { id: "nature:spouting_whale", label: "spouting whale", names: ["spouting_whale"] },
    { id: "nature:whale", label: "whale", names: ["whale"] },
    { id: "nature:dolphin", label: "dolphin", names: ["dolphin"] },
    { id: "nature:seal", label: "seal", names: ["seal"] },
    { id: "nature:fish", label: "fish", names: ["fish"] },
    { id: "nature:tropical_fish", label: "tropical fish", names: ["tropical_fish"] },
    { id: "nature:blowfish", label: "blowfish", names: ["blowfish"] },
    { id: "nature:shark", label: "shark", names: ["shark"] },
    { id: "nature:octopus", label: "octopus", names: ["octopus"] },
    { id: "nature:spiral_shell", label: "spiral shell", names: ["spiral_shell", "shell"] },

    // animal bugs
    { id: "nature:bug", label: "bug", names: ["bug"] },
    { id: "nature:ant", label: "ant", names: ["ant"] },
    { id: "nature:honeybee", label: "honeybee", names: ["honeybee", "bee"] },
    { id: "nature:ladybug", label: "ladybug", names: ["ladybug"] },
    { id: "nature:cricket", label: "cricket", names: ["cricket"] },
    { id: "nature:spider", label: "spider", names: ["spider"] },
    { id: "nature:spider_web", label: "spider web", names: ["spider_web"] },
    { id: "nature:butterfly", label: "butterfly", names: ["butterfly"] },
    { id: "nature:microbe", label: "microbe", names: ["microbe"] },
    { id: "nature:fly", label: "fly", names: ["fly"] },
    { id: "nature:worm", label: "worm", names: ["worm"] },
    { id: "nature:beetle", label: "beetle", names: ["beetle"] },
    { id: "nature:cockroach", label: "cockroach", names: ["cockroach"] },
    { id: "nature:scorpion", label: "scorpion", names: ["scorpion"] },
    { id: "nature:jellyfish", label: "jellyfish", names: ["jellyfish"] },
    { id: "nature:coral", label: "coral", names: ["coral"] },

    // plant flowers
    { id: "nature:bouquet", label: "bouquet", names: ["bouquet"] },
    { id: "nature:cherry_blossom", label: "cherry blossom", names: ["cherry_blossom"] },
    { id: "nature:white_flower", label: "white flower", names: ["white_flower"] },
    { id: "nature:rose", label: "rose", names: ["rose"] },
    { id: "nature:hibiscus", label: "hibiscus", names: ["hibiscus"] },
    { id: "nature:sunflower", label: "sunflower", names: ["sunflower"] },
    { id: "nature:blossom", label: "blossom", names: ["blossom"] },
    { id: "nature:tulip", label: "tulip", names: ["tulip"] },

    // plant other
    { id: "nature:seedling", label: "seedling", names: ["seedling"] },
    { id: "nature:evergreen_tree", label: "evergreen tree", names: ["evergreen_tree"] },
    { id: "nature:deciduous_tree", label: "deciduous tree", names: ["deciduous_tree"] },
    { id: "nature:palm_tree", label: "palm tree", names: ["palm_tree"] },
    { id: "nature:cactus", label: "cactus", names: ["cactus"] },
    { id: "nature:sheaf_of_rice", label: "sheaf of rice", names: ["sheaf_of_rice"] },
    { id: "nature:herb", label: "herb", names: ["herb"] },
    { id: "nature:four_leaf_clover", label: "four leaf clover", names: ["four_leaf_clover"] },
    { id: "nature:maple_leaf", label: "maple leaf", names: ["maple_leaf"] },
    { id: "nature:fallen_leaf", label: "fallen leaf", names: ["fallen_leaf"] },
    { id: "nature:leaf_fluttering_in_wind", label: "leaf fluttering in wind", names: ["leaf_fluttering_in_wind"] },
    { id: "nature:mushroom", label: "mushroom", names: ["mushroom"] },
    { id: "nature:wilted_flower", label: "wilted flower", names: ["wilted_flower"] },
    { id: "nature:lotus", label: "lotus", names: ["lotus"] },
    { id: "nature:potted_plant", label: "potted plant", names: ["potted_plant"] },
    { id: "nature:wood", label: "wood", names: ["wood"] },

    // sky & weather
    { id: "nature:moon/new", label: "new moon", names: ["new_moon"] },
    { id: "nature:moon/waxing_crescent", label: "waxing crescent", names: ["waxing_crescent"] },
    { id: "nature:moon/first_quarter", label: "first quarter", names: ["first_quarter"] },
    { id: "nature:moon/waxing_gibbous", label: "waxing gibbous", names: ["waxing_gibbous"] },
    { id: "nature:moon/full", label: "full moon", names: ["full_moon"] },
    { id: "nature:moon/waning_gibbous", label: "waning gibbous", names: ["waning_gibbous"] },
    { id: "nature:moon/last_quarter", label: "last quarter", names: ["last_quarter"] },
    { id: "nature:moon/waning_crescent", label: "waning crescent", names: ["waning_crescent"] },
    { id: "nature:moon/crescent", label: "crescent moon", names: ["crescent_moon"] },
    { id: "nature:moon/new_with_face", label: "new moon with face", names: ["new_moon_with_face"] },
    { id: "nature:moon/first_quarter_face", label: "first quarter moon with face", names: ["first_quarter_moon_with_face"] },
    { id: "nature:moon/last_quarter_face", label: "last quarter moon with face", names: ["last_quarter_moon_with_face"] },
    { id: "nature:sun", label: "sun", names: ["sun"] },
    { id: "nature:sun/with_face", label: "sun with face", names: ["sun_with_face"] },
    { id: "nature:moon/full_with_face", label: "full moon with face", names: ["full_moon_with_face"] },
    { id: "nature:astro/star", label: "star", names: ["star"] },
    { id: "nature:astro/glowing_star", label: "glowing star", names: ["glowing_star"] },
    { id: "nature:astro/shooting_star", label: "shooting star", names: ["shooting_star"] },
    { id: "nature:astro/milky_way", label: "milky way", names: ["milky_way"] },
    { id: "nature:astro/comet", label: "comet", names: ["comet"] },
    { id: "nature:cloud", label: "cloud", names: ["cloud"] },
    { id: "nature:sun/behind_cloud", label: "sun behind cloud", names: ["sun_behind_cloud"] },
    { id: "nature:cloud/lightning_and_rain", label: "cloud with lightning and rain", names: ["cloud_with_lightning_and_rain"] },
    { id: "nature:sun/behind_small_cloud", label: "sun behind small cloud", names: ["sun_behind_small_cloud"] },
    { id: "nature:sun/behind_large_cloud", label: "sun behind large cloud", names: ["sun_behind_large_cloud"] },
    { id: "nature:sun/behind_rain_cloud", label: "sun behind rain cloud", names: ["sun_behind_rain_cloud"] },
    { id: "nature:cloud/rain", label: "cloud with rain", names: ["cloud_with_rain"] },
    { id: "nature:cloud/snow", label: "cloud with snow", names: ["cloud_with_snow"] },
    { id: "nature:cloud/lightning", label: "cloud with lightning", names: ["cloud_with_lightning"] },
    { id: "nature:tornado", label: "tornado", names: ["tornado"] },
    { id: "nature:fog", label: "fog", names: ["fog"] },
    { id: "nature:wind_face", label: "wind face", names: ["wind_face"] },
    { id: "nature:cyclone", label: "cyclone", names: ["cyclone"] },
    { id: "nature:rainbow", label: "rainbow", names: ["rainbow"] },
    { id: "nature:umbrella/closed", label: "closed umbrella", names: ["closed_umbrella"] },
    { id: "nature:umbrella/rain_drops", label: "umbrella with rain drops", names: ["umbrella_with_rain_drops"] },
    { id: "nature:umbrella", label: "umbrella", names: ["umbrella"] },
    { id: "nature:high_voltage", label: "high voltage", names: ["high_voltage"] },
    { id: "nature:snowflake", label: "snowflake", names: ["snowflake"] },
    { id: "nature:snowman", label: "snowman", names: ["snowman"] },
    { id: "nature:snowman/without_snow", label: "snowman without snow", names: ["snowman_without_snow"] },
    { id: "nature:fire", label: "fire", names: ["fire"] },
    { id: "nature:droplet", label: "droplet", names: ["droplet"] },
    { id: "nature:water_wave", label: "water wave", names: ["water_wave"] },
    { id: "nature:lion", label: "lion", names: ["lion"] },
    { id: "nature:moose", label: "moose", names: ["moose"] },
    { id: "nature:donkey", label: "donkey", names: ["donkey"] },
    { id: "nature:deer", label: "deer", names: ["deer"] },
    { id: "nature:bison", label: "bison", names: ["bison"] },
    { id: "nature:cow_face", label: "cow face", names: ["cow_face"] },
    { id: "nature:ox", label: "ox", names: ["ox"] },
    { id: "nature:water_buffalo", label: "water buffalo", names: ["water_buffalo"] },
    { id: "nature:bat", label: "bat", names: ["bat"] },
    { id: "nature:parrot", label: "parrot", names: ["parrot"] },
    { id: "nature:wing", label: "wing", names: ["wing"] },
    { id: "nature:black_bird", label: "black bird", names: ["black_bird"] },
    { id: "nature:goose", label: "goose", names: ["goose"] },
    { id: "nature:phoenix", label: "phoenix", names: ["phoenix"] },
    { id: "nature:crab", label: "crab", names: ["crab"] },
    { id: "nature:lobster", label: "lobster", names: ["lobster"] },
    { id: "nature:shrimp", label: "shrimp", names: ["shrimp"] },
    { id: "nature:squid", label: "squid", names: ["squid"] },
    { id: "nature:oyster", label: "oyster", names: ["oyster"] },
    { id: "nature:snail", label: "snail", names: ["snail"] },
    { id: "nature:mosquito", label: "mosquito", names: ["mosquito"] },
    { id: "nature:rosette", label: "rosette", names: ["rosette"] },
    { id: "nature:hyacinth", label: "hyacinth", names: ["hyacinth"] },
    { id: "nature:shamrock", label: "shamrock", names: ["shamrock"] },
    { id: "nature:empty_nest", label: "empty nest", names: ["empty_nest"] },
    { id: "nature:nest_with_eggs", label: "nest with eggs", names: ["nest_with_eggs"] },
    { id: "nature:leafless_tree", label: "leafless tree", names: ["leafless_tree"] },

    // food & drink
    // food fruits
    { id: "food:grapes", label: "grapes", names: ["grapes"] },
    { id: "food:melon", label: "melon", names: ["melon"] },
    { id: "food:watermelon", label: "watermelon", names: ["watermelon"] },
    { id: "food:tangerine", label: "tangerine", names: ["tangerine"] },
    { id: "food:lemon", label: "lemon", names: ["lemon"] },
    { id: "food:banana", label: "banana", names: ["banana"] },
    { id: "food:pineapple", label: "pineapple", names: ["pineapple"] },
    { id: "food:mango", label: "mango", names: ["mango"] },
    { id: "food:red_apple", label: "red apple", names: ["red_apple"] },
    { id: "food:green_apple", label: "green apple", names: ["green_apple"] },
    { id: "food:pear", label: "pear", names: ["pear"] },
    { id: "food:peach", label: "peach", names: ["peach"] },
    { id: "food:cherries", label: "cherries", names: ["cherries"] },
    { id: "food:strawberry", label: "strawberry", names: ["strawberry"] },
    { id: "food:blueberries", label: "blueberries", names: ["blueberries"] },
    { id: "food:kiwi", label: "kiwi", names: ["kiwi"] },
    { id: "food:tomato", label: "tomato", names: ["tomato"] },

    // food vegetables
    { id: "food:avocado", label: "avocado", names: ["avocado"] },
    { id: "food:eggplant", label: "eggplant", names: ["eggplant"] },
    { id: "food:potato", label: "potato", names: ["potato"] },
    { id: "food:carrot", label: "carrot", names: ["carrot"] },
    { id: "food:corn", label: "corn", names: ["corn"] },
    { id: "food:hot_pepper", label: "hot pepper", names: ["hot_pepper"] },
    { id: "food:garlic", label: "garlic", names: ["garlic"] },
    { id: "food:onion", label: "onion", names: ["onion"] },
    { id: "food:peanuts", label: "peanuts", names: ["peanuts"] },

    // food prepared
    { id: "food:hamburger", label: "hamburger", names: ["hamburger"] },
    { id: "food:pizza", label: "pizza", names: ["pizza"] },
    { id: "food:meat_on_bone", label: "meat on bone", names: ["meat_on_bone"] },
    { id: "food:poultry_leg", label: "poultry leg", names: ["poultry_leg"] },
    { id: "food:cut_of_meat", label: "cut of meat", names: ["cut_of_meat"] },

    // food asian
    { id: "food:rice_cracker", label: "rice cracker", names: ["rice_cracker"] },
    { id: "food:rice_ball", label: "rice ball", names: ["rice_ball"] },
    { id: "food:cooked_rice", label: "cooked rice", names: ["cooked_rice"] },
    { id: "food:curry_rice", label: "curry rice", names: ["curry_rice"] },
    { id: "food:steaming_bowl", label: "steaming bowl", names: ["steaming_bowl"] },
    { id: "food:spaghetti", label: "spaghetti", names: ["spaghetti"] },
    { id: "food:bread", label: "bread", names: ["bread"] },
    { id: "food:french_fries", label: "french fries", names: ["french_fries"] },
    { id: "food:roasted_sweet_potato", label: "roasted sweet potato", names: ["roasted_sweet_potato"] },
    { id: "food:dango", label: "dango", names: ["dango"] },
    { id: "food:oden", label: "oden", names: ["oden"] },
    { id: "food:sushi", label: "sushi", names: ["sushi"] },
    { id: "food:fried_shrimp", label: "fried shrimp", names: ["fried_shrimp"] },
    { id: "food:fish_cake", label: "fish cake", names: ["fish_cake"] },

    // food sweet
    { id: "food:soft_ice_cream", label: "soft ice cream", names: ["soft_ice_cream", "icecream"] },
    { id: "food:shaved_ice", label: "shaved ice", names: ["shaved_ice"] },
    { id: "food:ice_cream", label: "ice cream", names: ["ice_cream"] },
    { id: "food:doughnut", label: "doughnut", names: ["doughnut"] },
    { id: "food:cookie", label: "cookie", names: ["cookie"] },
    { id: "food:chocolate_bar", label: "chocolate bar", names: ["chocolate_bar"] },
    { id: "food:candy", label: "candy", names: ["candy"] },
    { id: "food:lollipop", label: "lollipop", names: ["lollipop"] },
    { id: "food:custard", label: "custard", names: ["custard"] },
    { id: "food:honey_pot", label: "honey pot", names: ["honey_pot"] },
    { id: "food:shortcake", label: "shortcake", names: ["shortcake"] },

    // dishware
    { id: "food:bento_box", label: "bento box", names: ["bento_box", "bento"] },
    { id: "food:pot_of_food", label: "pot of food", names: ["pot_of_food", "stew"] },
    { id: "food:cooking", label: "cooking", names: ["cooking"] },
    { id: "food:fork_and_knife", label: "fork and knife", names: ["fork_and_knife"] },

    // drinks
    { id: "food:teacup_without_handle", label: "teacup without handle", names: ["teacup_without_handle", "teacup"] },
    { id: "food:sake", label: "sake", names: ["sake"] },
    { id: "food:wine_glass", label: "wine glass", names: ["wine_glass"] },
    { id: "food:cocktail_glass", label: "cocktail glass", names: ["cocktail_glass", "cocktail"] },
    { id: "food:tropical_drink", label: "tropical drink", names: ["tropical_drink"] },
    { id: "food:beer_mug", label: "beer mug", names: ["beer_mug", "beer"] },
    { id: "food:clinking_beer_mugs", label: "clinking beer mugs", names: ["clinking_beer_mugs", "beers"] },
    { id: "food:baby_bottle", label: "baby bottle", names: ["baby_bottle"] },
    { id: "food:croissant", label: "croissant", names: ["croissant"] },
    { id: "food:baguette_bread", label: "baguette bread", names: ["baguette_bread"] },
    { id: "food:green_salad", label: "green salad", names: ["green_salad", "salad"] },
    { id: "food:shallow_pan_of_food", label: "shallow pan of food", names: ["shallow_pan_of_food"] },
    { id: "food:stuffed_flatbread", label: "stuffed flatbread", names: ["stuffed_flatbread"] },
    { id: "food:egg", label: "egg", names: ["egg"] },
    { id: "food:pancakes", label: "pancakes", names: ["pancakes"] },
    { id: "food:cheese_sector", label: "cheese", names: ["cheese", "cheese_sector"] },
    { id: "food:cupcake", label: "cupcake", names: ["cupcake"] },
    { id: "food:salt", label: "salt", names: ["salt"] },
    { id: "food:bagel", label: "bagel", names: ["bagel"] },
    { id: "food:mate_drink", label: "mate drink", names: ["mate_drink", "mate"] },
    { id: "food:ice_cube", label: "ice cube", names: ["ice_cube"] },
    { id: "food:fortune_cookie", label: "fortune cookie", names: ["fortune_cookie"] },
    { id: "food:takeout_box", label: "takeout box", names: ["takeout_box"] },
    { id: "food:dumpling", label: "dumpling", names: ["dumpling"] },
    { id: "food:waffle", label: "waffle", names: ["waffle"] },
    { id: "food:falafel", label: "falafel", names: ["falafel"] },
    { id: "food:butter", label: "butter", names: ["butter"] },
    { id: "food:hot_dog", label: "hot dog", names: ["hot_dog"] },
    { id: "food:taco", label: "taco", names: ["taco"] },
    { id: "food:burrito", label: "burrito", names: ["burrito"] },
    { id: "food:beverage_box", label: "beverage box", names: ["beverage_box"] },
    { id: "food:moon_cake", label: "moon cake", names: ["moon_cake"] },
    { id: "food:glass_of_milk", label: "glass of milk", names: ["glass_of_milk", "milk"] },
    { id: "food:hot_beverage", label: "hot beverage", names: ["hot_beverage", "coffee"] },
    { id: "food:cup_with_straw", label: "cup with straw", names: ["cup_with_straw"] },
    { id: "food:bubble_tea", label: "bubble tea", names: ["bubble_tea"] },
    { id: "food:pot_sticker", label: "pot sticker", names: ["pot_sticker"] },
    { id: "food:plate_with_knife_and_fork", label: "plate with knife and fork", names: ["plate_with_knife_and_fork"] },
    { id: "food:bottle_with_popping_cork", label: "champagne", names: ["champagne", "bottle_with_popping_cork"] },
    { id: "food:popcorn", label: "popcorn", names: ["popcorn"] },
    { id: "food:chopsticks", label: "chopsticks", names: ["chopsticks"] },
    { id: "food:bowl_with_spoon", label: "bowl with spoon", names: ["bowl_with_spoon"] },
    { id: "food:coconut", label: "coconut", names: ["coconut"] },
    { id: "food:teapot", label: "teapot", names: ["teapot"] },
    { id: "food:pouring_liquid", label: "pouring liquid", names: ["pouring_liquid"] },
    { id: "food:broccoli", label: "broccoli", names: ["broccoli"] },
    { id: "food:pie", label: "pie", names: ["pie"] },
    { id: "food:pretzel", label: "pretzel", names: ["pretzel"] },
    { id: "food:sandwich", label: "sandwich", names: ["sandwich"] },
    { id: "food:canned_food", label: "canned food", names: ["canned_food"] },
    { id: "food:leafy_green", label: "leafy green", names: ["leafy_green"] },
    { id: "food:lime", label: "lime", names: ["lime"] },
    { id: "food:olive", label: "olive", names: ["olive"] },
    { id: "food:bell_pepper", label: "bell pepper", names: ["bell_pepper"] },
    { id: "food:beans", label: "beans", names: ["beans"] },
    { id: "food:chestnut", label: "chestnut", names: ["chestnut"] },
    { id: "food:pea_pod", label: "pea pod", names: ["pea_pod"] },
    { id: "food:brown_mushroom", label: "brown mushroom", names: ["brown_mushroom"] },
    { id: "food:root_vegetable", label: "root vegetable", names: ["root_vegetable"] },
    { id: "food:flatbread", label: "flatbread", names: ["flatbread"] },
    { id: "food:bacon", label: "bacon", names: ["bacon"] },
    { id: "food:tamale", label: "tamale", names: ["tamale"] },
    { id: "food:fondue", label: "fondue", names: ["fondue"] },
    { id: "food:clinking_glasses", label: "clinking glasses", names: ["clinking_glasses"] },
    { id: "food:tumbler_glass", label: "tumbler glass", names: ["tumbler_glass"] },
    { id: "food:spoon", label: "spoon", names: ["spoon"] },
    { id: "food:jar", label: "jar", names: ["jar"] },

    // travel & places
    // place geographic
    { id: "travel:japan/fuji", label: "fuji", names: ["fuji", "mount_fuji"] },
    { id: "travel:night_stars", label: "night stars", names: ["night_stars"] },
    { id: "travel:sunrise_mountain", label: "sunrise mountain", names: ["sunrise_mountain"] },
    { id: "travel:sunrise", label: "sunrise", names: ["sunrise"] },
    { id: "travel:city_sunset", label: "city sunset", names: ["city_sunset"] },
    { id: "travel:sunset", label: "sunset", names: ["sunset"] },
    { id: "travel:bridge", label: "bridge", names: ["bridge"] },
    { id: "travel:volcano", label: "volcano", names: ["volcano"] },
    { id: "travel:globe", label: "globe", names: ["globe"] },

    // place buildings
    { id: "travel:house", label: "house", names: ["house"] },
    { id: "travel:house_with_garden", label: "house with garden", names: ["house_with_garden"] },
    { id: "travel:office_building", label: "office building", names: ["office_building"] },
    { id: "travel:post_office", label: "post office", names: ["post_office"] },
    { id: "travel:european_post_office", label: "european post office", names: ["european_post_office"] },
    { id: "travel:hospital", label: "hospital", names: ["hospital"] },
    { id: "travel:bank", label: "bank", names: ["bank"] },
    { id: "travel:atm", label: "atm", names: ["atm"] },
    { id: "travel:hotel", label: "hotel", names: ["hotel"] },
    { id: "travel:love_hotel", label: "love hotel", names: ["love_hotel"] },
    { id: "travel:convenience_store", label: "convenience store", names: ["convenience_store"] },
    { id: "travel:school", label: "school", names: ["school"] },
    { id: "travel:department_store", label: "department store", names: ["department_store"] },
    { id: "travel:factory", label: "factory", names: ["factory"] },
    { id: "travel:japan/lantern", label: "lantern", names: ["lantern"] },
    { id: "travel:japan/castle", label: "Japan castle", names: ["japan_castle"] },
    { id: "travel:castle", label: "castle", names: ["castle"] },

    // place religious
    { id: "travel:church", label: "church", names: ["church"] },
    { id: "travel:fountain", label: "fountain", names: ["fountain"] },
    { id: "travel:sailboat", label: "sailboat", names: ["sailboat"] },
    { id: "travel:tent", label: "tent", names: ["tent"] },
    { id: "travel:fuel_pump", label: "fuel pump", names: ["fuel_pump"] },
    { id: "travel:japan/tokyo_tower", label: "tokyo tower", names: ["tokyo_tower"] },
    { id: "travel:statue_of_liberty", label: "statue of liberty", names: ["statue_of_liberty"] },
    { id: "travel:japan/map", label: "map", names: ["map"] },
    { id: "travel:japan/moyai", label: "moyai", names: ["moyai"] },

    // place other
    { id: "travel:ferris_wheel", label: "ferris wheel", names: ["ferris_wheel"] },
    { id: "travel:roller_coaster", label: "roller coaster", names: ["roller_coaster"] },
    { id: "travel:carousel", label: "carousel", names: ["carousel"] },
    { id: "travel:bullseye", label: "bullseye", names: ["bullseye"] },
    { id: "travel:snow_mountain", label: "snow mountain", names: ["snow_mountain"] },
    { id: "travel:camping", label: "camping", names: ["camping"] },
    { id: "travel:beach", label: "beach", names: ["beach"] },
    { id: "travel:construction", label: "construction", names: ["construction"] },
    { id: "travel:houses", label: "houses", names: ["houses"] },
    { id: "travel:cityscape", label: "cityscape", names: ["cityscape"] },
    { id: "travel:old_house", label: "old house", names: ["old_house"] },
    { id: "travel:temple", label: "temple", names: ["temple"] },
    { id: "travel:desert", label: "desert", names: ["desert"] },
    { id: "travel:island", label: "island", names: ["island"] },
    { id: "travel:park", label: "park", names: ["park"] },
    { id: "travel:stadium", label: "stadium", names: ["stadium"] },

    // transport air
    { id: "travel:vehicle/rocket", label: "rocket", names: ["rocket"] },
    { id: "travel:vehicle/helicopter", label: "helicopter", names: ["helicopter"] },

    // transport ground
    { id: "travel:vehicle/steam_train", label: "steam train", names: ["steam_train", "steam_locomotive"] },
    { id: "travel:vehicle/train_car", label: "train car", names: ["train_car"] },
    { id: "travel:vehicle/bullet_train_300", label: "bullet train 300", names: ["bullet_train_300", "bullettrain_side"] },
    { id: "travel:vehicle/bullet_train", label: "bullet train", names: ["bullet_train", "bullettrain_front"] },
    { id: "travel:vehicle/train", label: "train", names: ["train"] },
    { id: "travel:vehicle/subway", label: "subway", names: ["subway"] },
    { id: "travel:vehicle/light_rail", label: "light rail", names: ["light_rail"] },
    { id: "travel:vehicle/station", label: "station", names: ["station"] },
    { id: "travel:vehicle/tram", label: "tram", names: ["tram"] },
    { id: "travel:vehicle/tram_car", label: "tram car", names: ["tram_car"] },
    { id: "travel:vehicle/bus", label: "bus", names: ["bus"] },
    { id: "travel:vehicle/oncoming_bus", label: "oncoming bus", names: ["oncoming_bus"] },
    { id: "travel:vehicle/trolleybus", label: "trolleybus", names: ["trolleybus"] },
    { id: "travel:vehicle/bus_stop", label: "bus stop", names: ["bus_stop"] },
    { id: "travel:vehicle/minibus", label: "minibus", names: ["minibus"] },
    { id: "travel:vehicle/ambulance", label: "ambulance", names: ["ambulance"] },
    { id: "travel:vehicle/fire_engine", label: "fire engine", names: ["fire_engine"] },
    { id: "travel:vehicle/police_car", label: "police car", names: ["police_car"] },
    { id: "travel:vehicle/oncoming_police_car", label: "oncoming police car", names: ["oncoming_police_car"] },
    { id: "travel:vehicle/taxi", label: "taxi", names: ["taxi"] },
    { id: "travel:vehicle/oncoming_taxi", label: "oncoming taxi", names: ["oncoming_taxi"] },
    { id: "travel:vehicle/car", label: "car", names: ["car", "red_car"] },
    { id: "travel:vehicle/oncoming_car", label: "oncoming car", names: ["oncoming_car"] },
    { id: "travel:vehicle/rv", label: "rv", names: ["rv"] },
    { id: "travel:vehicle/truck", label: "truck", names: ["truck"] },
    { id: "travel:vehicle/semi", label: "semi", names: ["semi"] },
    { id: "travel:vehicle/tractor", label: "tractor", names: ["tractor"] },
    { id: "travel:vehicle/monorail", label: "monorail", names: ["monorail"] },
    { id: "travel:vehicle/mountain_train", label: "mountain train", names: ["mountain_train"] },
    { id: "travel:vehicle/suspension_railway", label: "suspension railway", names: ["suspension_railway"] },
    { id: "travel:vehicle/cableway", label: "cableway", names: ["cableway"] },
    { id: "travel:vehicle/aerial_tram", label: "aerial tram", names: ["aerial_tram"] },

    // transport water
    { id: "travel:vehicle/ship", label: "ship", names: ["ship"] },
    { id: "travel:vehicle/speedboat", label: "speedboat", names: ["speedboat"] },
    { id: "travel:vehicle/satellite", label: "satellite", names: ["satellite"] },
    { id: "travel:vehicle/cruise_ship", label: "cruise ship", names: ["cruise_ship"] },
    { id: "travel:vehicle/scooter", label: "scooter", names: ["scooter"] },
    { id: "travel:vehicle/motor_scooter", label: "motor scooter", names: ["motor_scooter"] },
    { id: "travel:vehicle/canoe", label: "canoe", names: ["canoe"] },
    { id: "travel:vehicle/sled", label: "sled", names: ["sled"] },
    { id: "travel:vehicle/ufo", label: "ufo", names: ["ufo"] },
    { id: "travel:vehicle/skateboard", label: "skateboard", names: ["skateboard"] },
    { id: "travel:vehicle/rickshaw", label: "rickshaw", names: ["rickshaw"] },
    { id: "travel:vehicle/cable_car", label: "cable car", names: ["cable_car"] },
    { id: "travel:vehicle/tramway", label: "tramway", names: ["tramway"] },
    { id: "travel:vehicle/plane", label: "plane", names: ["plane", "airplane"] },

    // transport sign
    { id: "travel:traffic_light_h", label: "traffic light h", names: ["traffic_light_h"] },
    { id: "travel:traffic_light_v", label: "traffic light v", names: ["traffic_light_v"] },
    { id: "travel:roadblock", label: "roadblock", names: ["roadblock"] },
    { id: "travel:siren", label: "siren", names: ["siren"] },
    { id: "travel:flag", label: "flag", names: ["flag"] },
    { id: "travel:door", label: "door", names: ["door"] },
    { id: "travel:no_entry", label: "no entry", names: ["no_entry"] },
    { id: "travel:smoking", label: "smoking", names: ["smoking"] },
    { id: "travel:no_smoking", label: "no smoking", names: ["no_smoking"] },
    { id: "travel:trash_bin", label: "trash bin", names: ["trash_bin"] },
    { id: "travel:no_littering", label: "no littering", names: ["no_littering"] },
    { id: "travel:water_fountain", label: "water fountain", names: ["water_fountain"] },
    { id: "travel:non_potable_water", label: "non potable water", names: ["non_potable_water"] },
    { id: "travel:vehicle/bike", label: "bike", names: ["bike"] },
    { id: "travel:no_bikes", label: "no bikes", names: ["no_bikes"] },
    { id: "travel:cyclist", label: "cyclist", names: ["cyclist"] },
    { id: "travel:mountain_cyclist", label: "mountain cyclist", names: ["mountain_cyclist"] },
    { id: "travel:pedestrian", label: "pedestrian", names: ["pedestrian"] },
    { id: "travel:no_pedestrians", label: "no pedestrians", names: ["no_pedestrians"] },
    { id: "travel:crossing", label: "crossing", names: ["crossing"] },
    { id: "travel:men_room", label: "men room", names: ["men_room"] },
    { id: "travel:women_room", label: "women room", names: ["women_room"] },
    { id: "travel:restroom", label: "restroom", names: ["restroom"] },
    { id: "travel:baby_symbol", label: "baby symbol", names: ["baby_symbol"] },
    { id: "travel:toilet", label: "toilet", names: ["toilet"] },
    { id: "travel:wc", label: "wc", names: ["wc"] },
    { id: "travel:shower", label: "shower", names: ["shower"] },
    { id: "travel:bath", label: "bath", names: ["bath"] },
    { id: "travel:bathtub", label: "bathtub", names: ["bathtub"] },
    { id: "travel:passport_control", label: "passport control", names: ["passport_control"] },
    { id: "travel:customs", label: "customs", names: ["customs"] },
    { id: "travel:baggage_claim", label: "baggage claim", names: ["baggage_claim"] },
    { id: "travel:left_luggage", label: "left luggage", names: ["left_luggage"] },
    { id: "travel:couch_lamp", label: "couch lamp", names: ["couch_lamp"] },
    { id: "travel:sleeping", label: "person in bed", names: ["person_in_bed"] },
    { id: "travel:shopping_bags", label: "shopping bags", names: ["shopping_bags"] },
    { id: "travel:bellhop", label: "bellhop", names: ["bellhop"] },
    { id: "travel:bed", label: "bed", names: ["bed"] },
    { id: "travel:worship", label: "worship", names: ["worship"] },
    { id: "travel:stop_sign", label: "stop sign", names: ["stop_sign"] },
    { id: "travel:cart", label: "cart", names: ["cart"] },
    { id: "travel:temple_hindu", label: "temple hindu", names: ["temple_hindu"] },
    { id: "travel:hut", label: "hut", names: ["hut"] },
    { id: "travel:elevator", label: "elevator", names: ["elevator"] },
    { id: "travel:slide", label: "slide", names: ["slide"] },
    { id: "travel:wheel", label: "wheel", names: ["wheel"] },
    { id: "travel:buoy", label: "buoy", names: ["buoy"] },

    // place map
    { id: "travel:globe_showing_europe_africa", label: "globe showing Europe-Africa", names: ["globe_showing_europe_africa"] },
    { id: "travel:globe_showing_americas", label: "globe showing Americas", names: ["globe_showing_americas"] },
    { id: "travel:globe_showing_asia_australia", label: "globe showing Asia-Australia", names: ["globe_showing_asia_australia"] },
    { id: "travel:world_map", label: "world map", names: ["world_map"] },
    { id: "travel:compass", label: "compass", names: ["compass"] },
    { id: "travel:mountain", label: "mountain", names: ["mountain"] },
    { id: "travel:wedding", label: "wedding", names: ["wedding"] },
    { id: "travel:mosque", label: "mosque", names: ["mosque"] },
    { id: "travel:synagogue", label: "synagogue", names: ["synagogue"] },
    { id: "travel:kaaba", label: "kaaba", names: ["kaaba"] },
    { id: "travel:hot_springs", label: "hot springs", names: ["hot_springs"] },
    { id: "travel:barber_pole", label: "barber pole", names: ["barber_pole"] },
    { id: "travel:manual_wheelchair", label: "manual wheelchair", names: ["manual_wheelchair"] },
    { id: "travel:motorized_wheelchair", label: "motorized wheelchair", names: ["motorized_wheelchair"] },
    { id: "travel:anchor", label: "anchor", names: ["anchor"] },
    { id: "travel:ferry", label: "ferry", names: ["ferry"] },
    { id: "travel:airplane_departure", label: "airplane departure", names: ["airplane_departure"] },
    { id: "travel:airplane_arrival", label: "airplane arrival", names: ["airplane_arrival"] },

    // time
    { id: "travel:hourglass_done", label: "hourglass done", names: ["hourglass_done"] },
    { id: "travel:hourglass_not_done", label: "hourglass not done", names: ["hourglass_not_done"] },
    { id: "travel:watch", label: "watch", names: ["watch"] },
    { id: "travel:alarm_clock", label: "alarm clock", names: ["alarm_clock"] },
    { id: "travel:stopwatch", label: "stopwatch", names: ["stopwatch"] },
    { id: "travel:timer_clock", label: "timer clock", names: ["timer_clock"] },
    { id: "travel:thermometer", label: "thermometer", names: ["thermometer"] },
    { id: "travel:umbrella", label: "umbrella", names: ["umbrella_ground"] },
    { id: "travel:umbrella_on_ground", label: "umbrella on ground", names: ["umbrella_on_ground"] },

    // activities

    // events
    { id: "activities:balloon_ribbon", label: "balloon ribbon", names: ["balloon_ribbon"] },
    { id: "activities:gift", label: "gift", names: ["gift"] },
    { id: "activities:cake", label: "cake", names: ["cake", "birthday"] },
    { id: "activities:jack_o_lantern", label: "jack o lantern", names: ["jack_o_lantern"] },
    { id: "activities:christmas_tree", label: "christmas tree", names: ["christmas_tree"] },
    { id: "activities:santa", label: "santa", names: ["santa"] },
    { id: "activities:fireworks", label: "fireworks", names: ["fireworks"] },
    { id: "activities:sparkler", label: "sparkler", names: ["sparkler"] },
    { id: "activities:balloon", label: "balloon", names: ["balloon"] },
    { id: "activities:popper", label: "popper", names: ["popper", "tada"] },
    { id: "activities:confetti", label: "confetti", names: ["confetti", "confetti_ball"] },
    { id: "activities:tanabata", label: "tanabata", names: ["tanabata", "tanabata_tree"] },
    { id: "activities:japan/flag", label: "crossed flags", names: ["crossed_flags"] },
    { id: "activities:japan/kadomatsu", label: "kadomatsu", names: ["kadomatsu"] },
    { id: "activities:japan/dolls", label: "dolls", names: ["dolls"] },
    { id: "activities:japan/carp", label: "carp", names: ["carp"] },
    { id: "activities:wind_chime", label: "wind chime", names: ["wind_chime"] },
    { id: "activities:japan/moon_viewing", label: "moon viewing", names: ["moon_viewing"] },
    { id: "activities:backpack", label: "backpack", names: ["backpack", "school_satchel"] },
    { id: "activities:graduation", label: "graduation", names: ["graduation", "mortar_board"] },
    { id: "activities:fishing", label: "fishing", names: ["fishing", "fishing_pole_and_fish"] },
    { id: "activities:microphone", label: "microphone", names: ["microphone"] },
    { id: "activities:movie_camera", label: "movie camera", names: ["movie_camera"] },
    { id: "activities:cinema", label: "cinema", names: ["cinema"] },
    { id: "activities:headphones", label: "headphones", names: ["headphones"] },
    { id: "activities:palette", label: "palette", names: ["palette", "art"] },
    { id: "activities:top_hat", label: "top hat", names: ["top_hat", "tophat"] },
    { id: "activities:circus", label: "circus", names: ["circus", "circus_tent"] },
    { id: "activities:ticket", label: "ticket", names: ["ticket"] },
    { id: "activities:clapper", label: "clapper", names: ["clapper"] },
    { id: "activities:drama", label: "drama", names: ["drama"] },

    // games
    { id: "activities:controller", label: "controller", names: ["controller", "video_game"] },
    { id: "activities:slot", label: "slot", names: ["slot", "slot_machine"] },
    { id: "activities:billiards", label: "billiards", names: ["billiards", "8ball"] },
    { id: "activities:die", label: "die", names: ["die", "dice"] },
    { id: "activities:bowling", label: "bowling", names: ["bowling"] },
    { id: "activities:flower_playing_cards", label: "flower playing cards", names: ["flower_playing_cards"] },

    // music
    { id: "activities:music_note", label: "music note", names: ["music_note", "musical_note"] },
    { id: "activities:music_notes", label: "music notes", names: ["music_notes", "notes"] },
    { id: "activities:sax", label: "sax", names: ["sax", "saxophone"] },
    { id: "activities:guitar", label: "guitar", names: ["guitar"] },
    { id: "activities:piano", label: "piano", names: ["piano", "musical_keyboard"] },
    { id: "activities:trumpet", label: "trumpet", names: ["trumpet"] },
    { id: "activities:violin", label: "violin", names: ["violin"] },
    { id: "activities:score", label: "score", names: ["score", "musical_score"] },

    // sports
    { id: "activities:running_shirt", label: "running shirt", names: ["running_shirt"] },
    { id: "activities:tennis", label: "tennis", names: ["tennis"] },
    { id: "activities:skiing", label: "skiing", names: ["skiing"] },
    { id: "activities:basketball", label: "basketball", names: ["basketball"] },
    { id: "activities:checkered_flag", label: "checkered flag", names: ["checkered_flag"] },
    { id: "activities:snowboarder", label: "snowboarder", names: ["snowboarder"] },
    { id: "activities:runner", label: "runner", names: ["runner"] },
    { id: "activities:surfer", label: "surfer", names: ["surfer"] },

    // award medals
    { id: "activities:medal_sports", label: "medal sports", names: ["medal_sports", "sports_medal", "medal"] },
    { id: "activities:trophy", label: "trophy", names: ["trophy"] },
    { id: "activities:horse_racing", label: "horse racing", names: ["horse_racing"] },
    { id: "activities:football", label: "football", names: ["football"] },
    { id: "activities:rugby", label: "rugby", names: ["rugby"] },
    { id: "activities:swimmer", label: "swimmer", names: ["swimmer"] },
    { id: "activities:weightlifter", label: "weightlifter", names: ["weightlifter"] },
    { id: "activities:golfer", label: "golfer", names: ["golfer"] },
    { id: "activities:motorcycle", label: "motorcycle", names: ["motorcycle"] },
    { id: "activities:race_car", label: "race car", names: ["race_car"] },
    { id: "activities:cricket", label: "cricket game", names: ["cricket_game"] },
    { id: "activities:volleyball", label: "volleyball", names: ["volleyball"] },
    { id: "activities:field_hockey", label: "field hockey", names: ["field_hockey"] },
    { id: "activities:ice_hockey", label: "ice hockey", names: ["ice_hockey"] },
    { id: "activities:ping_pong", label: "ping pong", names: ["ping_pong"] },
    { id: "activities:badminton", label: "badminton", names: ["badminton"] },
    { id: "activities:boxing", label: "boxing", names: ["boxing"] },
    { id: "activities:archery", label: "archery", names: ["archery"] },
    { id: "activities:amphora", label: "amphora", names: ["amphora"] },
    { id: "activities:mobile", label: "mobile", names: ["mobile"] },
    { id: "activities:mobile_arrow", label: "mobile arrow", names: ["mobile_arrow"] },
    { id: "activities:vibration", label: "vibration", names: ["vibration"] },
    { id: "activities:mobile_off", label: "mobile off", names: ["mobile_off"] },
    { id: "activities:no_phones", label: "no phones", names: ["no_phones"] },
    { id: "activities:signal", label: "signal", names: ["signal"] },
    { id: "activities:camera", label: "camera", names: ["camera"] },
    { id: "activities:camera_flash", label: "camera flash", names: ["camera_flash"] },
    { id: "activities:video_camera", label: "video camera", names: ["video_camera"] },
    { id: "activities:tv", label: "tv", names: ["tv"] },
    { id: "activities:radio", label: "radio", names: ["radio"] },
    { id: "activities:videocassette", label: "videocassette", names: ["videocassette"] },
    { id: "activities:projector", label: "projector", names: ["projector"] },
    { id: "activities:sunglasses", label: "dark sunglasses", names: ["dark_sunglasses"] },
    { id: "activities:joystick", label: "joystick", names: ["joystick"] },
    { id: "activities:drum", label: "drum", names: ["drum", "drum_with_drumsticks"] },
    { id: "activities:goal_net", label: "goal net", names: ["goal_net"] },
    { id: "activities:medal/1st", label: "1st place medal", names: ["1st_place_medal", "gold_medal"] },
    { id: "activities:medal/2nd", label: "2nd place medal", names: ["2nd_place_medal", "silver_medal"] },
    { id: "activities:medal/3rd", label: "3rd place medal", names: ["3rd_place_medal", "bronze_medal"] },
    { id: "activities:martial_uniform", label: "martial uniform", names: ["martial_uniform"] },
    { id: "activities:curling", label: "curling", names: ["curling"] },
    { id: "activities:lacrosse", label: "lacrosse", names: ["lacrosse"] },
    { id: "activities:flying_disc", label: "flying disc", names: ["flying_disc"] },
    { id: "activities:softball", label: "softball", names: ["softball"] },

    // arts & crafts
    { id: "activities:jigsaw", label: "jigsaw", names: ["jigsaw", "puzzle_piece"] },
    { id: "activities:amulet", label: "amulet", names: ["amulet", "nazar_amulet"] },
    { id: "activities:golf", label: "golf", names: ["golf"] },
    { id: "activities:skier", label: "skier", names: ["skier"] },
    { id: "activities:ice_skate", label: "ice skate", names: ["ice_skate"] },
    { id: "activities:bounce_ball", label: "bounce ball", names: ["bounce_ball"] },
    { id: "activities:slingshot", label: "slingshot", names: ["slingshot"] },
    { id: "activities:sparkle", label: "sparkle", names: ["sparkle"] },
    { id: "activities:minus", label: "minus", names: ["minus"] },
    { id: "activities:divide", label: "divide", names: ["divide"] },
    { id: "activities:loop", label: "loop", names: ["loop"] },
    { id: "activities:loop_double", label: "loop double", names: ["loop_double"] },
    { id: "activities:black_square", label: "black square", names: ["black_square"] },
    { id: "activities:white_square", label: "white square", names: ["white_square"] },
    { id: "activities:firecracker", label: "firecracker", names: ["firecracker"] },
    { id: "activities:red_envelope", label: "red envelope", names: ["red_envelope"] },
    { id: "activities:reminder_ribbon", label: "reminder ribbon", names: ["reminder_ribbon"] },
    { id: "activities:admission_tickets", label: "admission tickets", names: ["admission_tickets"] },
    { id: "activities:military_medal", label: "military medal", names: ["military_medal"] },
    { id: "activities:diving_mask", label: "diving mask", names: ["diving_mask"] },
    { id: "activities:mirror_ball", label: "mirror ball", names: ["mirror_ball"] },
    { id: "activities:spade_suit", label: "spade suit", names: ["spade_suit"] },
    { id: "activities:diamond_suit", label: "diamond suit", names: ["diamond_suit"] },
    { id: "activities:club_suit", label: "club suit", names: ["club_suit"] },
    { id: "activities:chess_pawn", label: "chess pawn", names: ["chess_pawn"] },
    { id: "activities:joker", label: "joker", names: ["joker"] },
    { id: "activities:mahjong_red_dragon", label: "mahjong red dragon", names: ["mahjong_red_dragon"] },
    { id: "activities:framed_picture", label: "framed picture", names: ["framed_picture"] },

    // objects
    // clothing
    { id: "objects:ring", label: "ring", names: ["ring"] },
    { id: "objects:gem", label: "gem", names: ["gem"] },

    // money
    { id: "objects:money_bag", label: "money bag", names: ["money_bag", "moneybag"] },
    { id: "objects:currency_exchange", label: "currency exchange", names: ["currency_exchange"] },
    { id: "objects:dollar", label: "dollar", names: ["dollar"] },
    { id: "objects:credit_card", label: "credit card", names: ["credit_card"] },
    { id: "objects:yen", label: "yen", names: ["yen"] },
    { id: "objects:dollar_bill", label: "dollar bill", names: ["dollar_bill"] },
    { id: "objects:euro_bill", label: "euro bill", names: ["euro_bill"] },
    { id: "objects:pound_bill", label: "pound bill", names: ["pound_bill"] },
    { id: "objects:money_wings", label: "money wings", names: ["money_wings"] },
    { id: "objects:chart_up", label: "chart up", names: ["chart_up", "chart_with_upwards_trend"] },
    { id: "objects:seat", label: "seat", names: ["seat"] },

    // computers
    { id: "objects:computer", label: "computer", names: ["computer", "laptop"] },
    { id: "objects:briefcase", label: "briefcase", names: ["briefcase"] },
    { id: "objects:minidisc", label: "minidisc", names: ["minidisc"] },
    { id: "objects:floppy", label: "floppy", names: ["floppy"] },
    { id: "objects:cd", label: "cd", names: ["cd"] },
    { id: "objects:dvd", label: "dvd", names: ["dvd"] },

    // books & paper
    { id: "objects:folder_open", label: "folder open", names: ["folder_open", "open_file_folder"] },
    { id: "objects:folder", label: "folder", names: ["folder", "file_folder"] },
    { id: "objects:page_curl", label: "page curl", names: ["page_curl"] },
    { id: "objects:document", label: "document", names: ["document"] },
    { id: "objects:calendar", label: "calendar", names: ["calendar", "date"] },
    { id: "objects:tear_calendar", label: "tear calendar", names: ["tear_calendar"] },
    { id: "objects:card_index", label: "card index", names: ["card_index"] },
    { id: "objects:chart_increasing", label: "chart increasing", names: ["chart_increasing"] },
    { id: "objects:chart_decreasing", label: "chart decreasing", names: ["chart_decreasing", "chart_with_downwards_trend"] },
    { id: "objects:bar_chart", label: "bar chart", names: ["bar_chart"] },
    { id: "objects:clipboard", label: "clipboard", names: ["clipboard"] },
    { id: "objects:pushpin", label: "pushpin", names: ["pushpin"] },
    { id: "objects:pin", label: "pin", names: ["pin"] },
    { id: "objects:paperclip", label: "paperclip", names: ["paperclip"] },
    { id: "objects:ruler", label: "ruler", names: ["ruler", "straight_ruler"] },
    { id: "objects:triangle_ruler", label: "triangle ruler", names: ["triangle_ruler", "triangular_ruler"] },
    { id: "objects:bookmarks", label: "bookmarks", names: ["bookmarks"] },
    { id: "objects:ledger", label: "ledger", names: ["ledger"] },
    { id: "objects:notebook", label: "notebook", names: ["notebook"] },
    { id: "objects:notebook_decor", label: "notebook decor", names: ["notebook_decor"] },
    { id: "objects:book_closed", label: "book closed", names: ["book_closed", "closed_book"] },
    { id: "objects:book_open", label: "book open", names: ["book_open", "open_book", "book"] },
    { id: "objects:book_green", label: "book green", names: ["book_green", "green_book"] },
    { id: "objects:book_blue", label: "book blue", names: ["book_blue", "blue_book"] },
    { id: "objects:book_orange", label: "book orange", names: ["book_orange", "orange_book"] },
    { id: "objects:books", label: "books", names: ["books"] },
    { id: "objects:name_badge", label: "name badge", names: ["name_badge"] },
    { id: "objects:scroll", label: "scroll", names: ["scroll"] },
    { id: "objects:memo", label: "memo", names: ["memo"] },

    // phones
    { id: "objects:phone_receiver", label: "phone receiver", names: ["phone_receiver", "telephone_receiver"] },
    { id: "objects:pager", label: "pager", names: ["pager"] },
    { id: "objects:fax", label: "fax", names: ["fax"] },
    { id: "objects:satellite_dish", label: "satellite dish", names: ["satellite_dish"] },

    // sound
    { id: "objects:megaphone", label: "megaphone", names: ["megaphone", "mega"] },
    { id: "objects:bullhorn", label: "bullhorn", names: ["bullhorn", "loudspeaker"] },

    // mail
    { id: "objects:outbox", label: "outbox", names: ["outbox"] },
    { id: "objects:inbox", label: "inbox", names: ["inbox"] },
    { id: "objects:package", label: "package", names: ["package"] },
    { id: "objects:email", label: "email", names: ["email"] },
    { id: "objects:envelope_in", label: "envelope in", names: ["envelope_in"] },
    { id: "objects:envelope_sent", label: "envelope sent", names: ["envelope_sent"] },
    { id: "objects:mailbox_closed", label: "mailbox closed", names: ["mailbox_closed"] },
    { id: "objects:mailbox_open", label: "mailbox open", names: ["mailbox_open"] },
    { id: "objects:mailbox_unread", label: "mailbox unread", names: ["mailbox_unread"] },
    { id: "objects:mailbox_unread_closed", label: "mailbox unread closed", names: ["mailbox_unread_closed"] },
    { id: "objects:postbox", label: "postbox", names: ["postbox"] },
    { id: "objects:horn", label: "horn", names: ["horn"] },

    // writing
    { id: "objects:newspaper", label: "newspaper", names: ["newspaper"] },
    { id: "objects:shuffle", label: "shuffle", names: ["shuffle"] },
    { id: "objects:repeat", label: "repeat", names: ["repeat"] },
    { id: "objects:repeat_one", label: "repeat one", names: ["repeat_one"] },
    { id: "objects:reload", label: "reload", names: ["reload"] },
    { id: "objects:refresh", label: "refresh", names: ["refresh"] },
    { id: "objects:dim", label: "dim", names: ["dim"] },
    { id: "objects:bright", label: "bright", names: ["bright"] },
    { id: "objects:mute", label: "mute", names: ["mute"] },
    { id: "objects:volume_low", label: "volume low", names: ["volume_low"] },
    { id: "objects:volume_mid", label: "volume mid", names: ["volume_mid"] },
    { id: "objects:volume_high", label: "volume high", names: ["volume_high"] },
    { id: "objects:battery", label: "battery", names: ["battery"] },
    { id: "objects:plug", label: "plug", names: ["plug"] },
    { id: "objects:search", label: "search", names: ["search", "mag"] },
    { id: "objects:search_right", label: "search right", names: ["search_right", "mag_right"] },
    { id: "objects:lock_pen", label: "lock pen", names: ["lock_pen"] },
    { id: "objects:lock_key", label: "lock key", names: ["lock_key"] },
    { id: "objects:key", label: "key", names: ["key"] },
    { id: "objects:lock", label: "lock", names: ["lock"] },
    { id: "objects:unlock", label: "unlock", names: ["unlock"] },
    { id: "objects:bell", label: "bell", names: ["bell"] },
    { id: "objects:bell_slash", label: "bell slash", names: ["bell_slash"] },
    { id: "objects:bookmark", label: "bookmark", names: ["bookmark"] },
    { id: "objects:link", label: "link", names: ["link"] },
    { id: "objects:radio_button", label: "radio button", names: ["radio_button"] },
    { id: "objects:back", label: "back", names: ["back"] },
    { id: "objects:end", label: "end", names: ["end"] },
    { id: "objects:on", label: "on", names: ["on"] },
    { id: "objects:soon", label: "soon", names: ["soon"] },
    { id: "objects:top", label: "top", names: ["top"] },

    // tools
    { id: "objects:flashlight", label: "flashlight", names: ["flashlight"] },
    { id: "objects:wrench", label: "wrench", names: ["wrench"] },
    { id: "objects:hammer", label: "hammer", names: ["hammer"] },
    { id: "objects:nut_bolt", label: "nut bolt", names: ["nut_bolt"] },
    { id: "objects:knife", label: "knife", names: ["knife", "hocho"] },
    { id: "objects:gun", label: "gun", names: ["gun"] },

    // science
    { id: "objects:microscope", label: "microscope", names: ["microscope"] },
    { id: "objects:telescope", label: "telescope", names: ["telescope"] },
    { id: "objects:crystal_ball", label: "crystal ball", names: ["crystal_ball"] },

    // time
    { id: "objects:clock/1", label: "clock1", names: ["clock1", "1oclock"] },
    { id: "objects:clock/2", label: "clock2", names: ["clock2", "2oclock"] },
    { id: "objects:clock/3", label: "clock3", names: ["clock3", "3oclock"] },
    { id: "objects:clock/4", label: "clock4", names: ["clock4", "4oclock"] },
    { id: "objects:clock/5", label: "clock5", names: ["clock5", "5oclock"] },
    { id: "objects:clock/6", label: "clock6", names: ["clock6", "6oclock"] },
    { id: "objects:clock/7", label: "clock7", names: ["clock7", "7oclock"] },
    { id: "objects:clock/8", label: "clock8", names: ["clock8", "8oclock"] },
    { id: "objects:clock/9", label: "clock9", names: ["clock9", "9oclock"] },
    { id: "objects:clock/10", label: "clock10", names: ["clock10", "10oclock"] },
    { id: "objects:clock/11", label: "clock11", names: ["clock11", "11oclock"] },
    { id: "objects:clock/12", label: "clock12", names: ["clock12", "12oclock"] },
    { id: "objects:clock/1_30", label: "clock130", names: ["clock130", "1_30oclock", "half_past_1"] },
    { id: "objects:clock/2_30", label: "clock230", names: ["clock230", "2_30oclock", "half_past_2"] },
    { id: "objects:clock/3_30", label: "clock330", names: ["clock330", "3_30oclock", "half_past_3"] },
    { id: "objects:clock/4_30", label: "clock430", names: ["clock430", "4_30oclock", "half_past_4"] },
    { id: "objects:clock/5_30", label: "clock530", names: ["clock530", "5_30oclock", "half_past_5"] },
    { id: "objects:clock/6_30", label: "clock630", names: ["clock630", "6_30oclock", "half_past_6"] },
    { id: "objects:clock/7_30", label: "clock730", names: ["clock730", "7_30oclock", "half_past_7"] },
    { id: "objects:clock/8_30", label: "clock830", names: ["clock830", "8_30oclock", "half_past_8"] },
    { id: "objects:clock/9_30", label: "clock930", names: ["clock930", "9_30oclock", "half_past_9"] },
    { id: "objects:clock/10_30", label: "clock1030", names: ["clock1030", "10_30oclock", "half_past_10"] },
    { id: "objects:clock/11_30", label: "clock1130", names: ["clock1130", "11_30oclock", "half_past_11"] },
    { id: "objects:clock/12_30", label: "clock1230", names: ["clock1230", "12_30oclock", "half_past_12"] },
    { id: "objects:candle", label: "candle", names: ["candle"] },
    { id: "objects:clock/mantel", label: "mantel clock", names: ["mantel_clock"] },
    { id: "objects:hole", label: "hole", names: ["hole"] },
    { id: "objects:levitate", label: "levitate", names: ["levitate"] },
    { id: "objects:pen", label: "pen", names: ["pen"] },
    { id: "objects:fountain_pen", label: "fountain pen", names: ["fountain_pen"] },
    { id: "objects:paintbrush", label: "paintbrush", names: ["paintbrush"] },
    { id: "objects:crayon", label: "crayon", names: ["crayon"] },
    { id: "objects:card_file", label: "card file", names: ["card_file"] },
    { id: "objects:card_drawers", label: "card drawers", names: ["card_drawers"] },
    { id: "objects:cabinet", label: "cabinet", names: ["cabinet"] },
    { id: "objects:trash_can", label: "trash can", names: ["trash_can", "wastebasket"] },
    { id: "objects:notepad_spiral", label: "notepad spiral", names: ["notepad_spiral", "spiral_notepad"] },
    { id: "objects:calendar_spiral", label: "calendar spiral", names: ["calendar_spiral", "spiral_calendar"] },
    { id: "objects:clamp", label: "clamp", names: ["clamp"] },
    { id: "objects:old_key", label: "old key", names: ["old_key"] },
    { id: "objects:rolled_newspaper", label: "rolled newspaper", names: ["rolled_newspaper"] },
    { id: "objects:dagger", label: "dagger", names: ["dagger", "dagger_knife"] },
    { id: "objects:ballot_box", label: "ballot box", names: ["ballot_box", "ballot_box_with_ballot"] },
    { id: "objects:hammer_wrench", label: "hammer wrench", names: ["hammer_wrench", "hammer_and_wrench"] },
    { id: "objects:shield", label: "shield", names: ["shield"] },
    { id: "objects:oil_drum", label: "oil drum", names: ["oil_drum"] },
    { id: "objects:highway", label: "highway", names: ["highway"] },
    { id: "objects:tracks", label: "tracks", names: ["tracks"] },
    { id: "objects:boat", label: "boat", names: ["boat"] },
    { id: "objects:propeller_plane", label: "propeller plane", names: ["propeller_plane"] },
    { id: "objects:extinguisher", label: "extinguisher", names: ["extinguisher"] },
    { id: "objects:toolbox", label: "toolbox", names: ["toolbox"] },
    { id: "objects:brick", label: "brick", names: ["brick", "bricks"] },
    { id: "objects:magnet", label: "magnet", names: ["magnet"] },
    { id: "objects:luggage", label: "luggage", names: ["luggage"] },
    { id: "objects:lotion", label: "lotion", names: ["lotion"] },
    { id: "objects:thread", label: "thread", names: ["thread"] },
    { id: "objects:yarn", label: "yarn", names: ["yarn"] },
    { id: "objects:safety_pin", label: "safety pin", names: ["safety_pin"] },
    { id: "objects:teddy", label: "teddy", names: ["teddy", "teddy_bear"] },
    { id: "objects:broom", label: "broom", names: ["broom"] },
    { id: "objects:yoyo", label: "yoyo", names: ["yoyo", "yo_yo"] },
    { id: "objects:kite", label: "kite", names: ["kite"] },
    { id: "objects:parachute", label: "parachute", names: ["parachute"] },
    { id: "objects:boomerang", label: "boomerang", names: ["boomerang"] },
    { id: "objects:magic_wand", label: "magic wand", names: ["magic_wand"] },
    { id: "objects:pinata", label: "pinata", names: ["pinata"] },
    { id: "objects:nesting_dolls", label: "nesting dolls", names: ["nesting_dolls"] },
    { id: "objects:ringed_planet", label: "ringed planet", names: ["ringed_planet", "saturn"] },
    { id: "objects:chair", label: "chair", names: ["chair"] },
    { id: "objects:razor", label: "razor", names: ["razor"] },
    { id: "objects:axe", label: "axe", names: ["axe"] },
    { id: "objects:diaper", label: "diaper", names: ["diaper"] },
    { id: "objects:mirror", label: "mirror", names: ["mirror"] },
    { id: "objects:window", label: "window", names: ["window"] },
    { id: "objects:plunger", label: "plunger", names: ["plunger"] },
    { id: "objects:mouse_trap", label: "mouse trap", names: ["mouse_trap"] },
    { id: "objects:coin", label: "coin", names: ["coin"] },
    { id: "objects:toothbrush", label: "toothbrush", names: ["toothbrush"] },
    { id: "objects:shower_head", label: "shower head", names: ["shower_head"] },
    { id: "objects:bucket", label: "bucket", names: ["bucket"] },
    { id: "objects:hook", label: "hook", names: ["hook"] },
    { id: "objects:military_helmet", label: "military helmet", names: ["military_helmet"] },
    { id: "objects:accordion", label: "accordion", names: ["accordion"] },
    { id: "objects:long_drum", label: "long drum", names: ["long_drum"] },
    { id: "objects:coin_gold", label: "coin gold", names: ["coin_gold"] },
    { id: "objects:carpentry_saw", label: "carpentry saw", names: ["carpentry_saw"] },
    { id: "objects:screwdriver", label: "screwdriver", names: ["screwdriver"] },
    { id: "objects:ladder", label: "ladder", names: ["ladder"] },
    { id: "objects:gravestone", label: "gravestone", names: ["gravestone"] },
    { id: "objects:placard", label: "placard", names: ["placard"] },
    { id: "objects:rock", label: "rock", names: ["rock"] },
    { id: "objects:hair_slide", label: "hair slide", names: ["hair_slide"] },
    { id: "objects:spectacles", label: "spectacles", names: ["spectacles", "glasses"] },
    { id: "objects:magnifying_glass", label: "magnifying glass", names: ["magnifying_glass"] },
    { id: "objects:microscope_alternative", label: "microscope alternative", names: ["microscope_alternative"] },
    { id: "objects:telescope_alternative", label: "telescope alternative", names: ["telescope_alternative"] },
    { id: "objects:fly_swatter", label: "fly swatter", names: ["fly_swatter"] },
    { id: "objects:boxing_glove", label: "boxing glove", names: ["boxing_glove"] },
    { id: "objects:climbing_harness", label: "climbing harness", names: ["climbing_harness"] },
    { id: "objects:parachute_alternative", label: "parachute alternative", names: ["parachute_alternative"] },
    { id: "objects:skateboard_alternative", label: "skateboard alternative", names: ["skateboard_alternative"] },
    { id: "objects:sled_alternative", label: "sled alternative", names: ["sled_alternative"] },
    { id: "objects:wind_instrument", label: "wind instrument", names: ["wind_instrument"] },
    { id: "objects:string_instrument", label: "string instrument", names: ["string_instrument"] },
    { id: "objects:basket", label: "basket", names: ["basket"] },
    { id: "objects:toilet_paper", label: "toilet paper", names: ["toilet_paper", "roll_of_paper"] },
    { id: "objects:soap", label: "soap", names: ["soap"] },
    { id: "objects:sponge", label: "sponge", names: ["sponge"] },
    { id: "objects:receipt", label: "receipt", names: ["receipt"] },
    { id: "objects:pickaxe", label: "pickaxe", names: ["pickaxe"] },
    { id: "objects:helmet_white", label: "helmet white", names: ["helmet_white"] },
    { id: "objects:chains", label: "chains", names: ["chains"] },
    { id: "objects:scissors", label: "scissors", names: ["scissors"] },
    { id: "objects:check_box", label: "check box", names: ["check_box"] },
    { id: "objects:envelope", label: "envelope", names: ["envelope"] },
    { id: "objects:pencil", label: "pencil", names: ["pencil", "pencil2"] },
    { id: "objects:nib", label: "nib", names: ["nib"] },
    { id: "objects:check_mark", label: "check mark", names: ["check_mark"] },
    { id: "objects:x_mark", label: "x mark", names: ["x_mark"] },
    { id: "objects:cross", label: "cross", names: ["cross"] },
    { id: "objects:star_of_david", label: "star of david", names: ["star_of_david"] },

    // clothing
    { id: "objects:glasses", label: "glasses", names: ["eyeglasses"] },
    { id: "objects:goggles", label: "goggles", names: ["goggles"] },
    { id: "objects:lab_coat", label: "lab coat", names: ["lab_coat"] },
    { id: "objects:safety_vest", label: "safety vest", names: ["safety_vest"] },
    { id: "objects:necktie", label: "necktie", names: ["necktie"] },
    { id: "objects:t_shirt", label: "t-shirt", names: ["t_shirt"] },
    { id: "objects:jeans", label: "jeans", names: ["jeans"] },
    { id: "objects:scarf", label: "scarf", names: ["scarf"] },
    { id: "objects:gloves", label: "gloves", names: ["gloves"] },
    { id: "objects:coat", label: "coat", names: ["coat"] },
    { id: "objects:socks", label: "socks", names: ["socks"] },
    { id: "objects:dress", label: "dress", names: ["dress"] },
    { id: "objects:kimono", label: "kimono", names: ["kimono"] },
    { id: "objects:sari", label: "sari", names: ["sari"] },
    { id: "objects:one_piece_swimsuit", label: "one-piece swimsuit", names: ["one_piece_swimsuit"] },
    { id: "objects:briefs", label: "briefs", names: ["briefs"] },
    { id: "objects:shorts", label: "shorts", names: ["shorts"] },
    { id: "objects:bikini", label: "bikini", names: ["bikini"] },
    { id: "objects:woman_s_clothes", label: "woman’s clothes", names: ["woman_s_clothes"] },
    { id: "objects:purse", label: "purse", names: ["purse"] },
    { id: "objects:handbag", label: "handbag", names: ["handbag"] },
    { id: "objects:clutch_bag", label: "clutch bag", names: ["clutch_bag"] },
    { id: "objects:thong_sandal", label: "thong sandal", names: ["thong_sandal"] },
    { id: "objects:man_s_shoe", label: "man’s shoe", names: ["man_s_shoe"] },
    { id: "objects:running_shoe", label: "running shoe", names: ["running_shoe"] },
    { id: "objects:hiking_boot", label: "hiking boot", names: ["hiking_boot"] },
    { id: "objects:flat_shoe", label: "flat shoe", names: ["flat_shoe"] },
    { id: "objects:high_heeled_shoe", label: "high-heeled shoe", names: ["high_heeled_shoe"] },
    { id: "objects:woman_s_sandal", label: "woman’s sandal", names: ["woman_s_sandal"] },
    { id: "objects:ballet_shoes", label: "ballet shoes", names: ["ballet_shoes"] },
    { id: "objects:woman_s_boot", label: "woman’s boot", names: ["woman_s_boot"] },
    { id: "objects:crown", label: "crown", names: ["crown"] },
    { id: "objects:woman_s_hat", label: "woman’s hat", names: ["woman_s_hat"] },
    { id: "objects:billed_cap", label: "billed cap", names: ["billed_cap"] },
    { id: "objects:prayer_beads", label: "prayer beads", names: ["prayer_beads"] },
    { id: "objects:lipstick", label: "lipstick", names: ["lipstick"] },
    { id: "objects:studio_microphone", label: "studio microphone", names: ["studio_microphone"] },
    { id: "objects:level_slider", label: "level slider", names: ["level_slider"] },
    { id: "objects:control_knobs", label: "control knobs", names: ["control_knobs"] },
    { id: "objects:maracas", label: "maracas", names: ["maracas"] },
    { id: "objects:flute", label: "flute", names: ["flute"] },
    { id: "objects:harp", label: "harp", names: ["harp"] },
    { id: "objects:telephone", label: "telephone", names: ["telephone"] },
    { id: "objects:desktop_computer", label: "desktop computer", names: ["desktop_computer"] },
    { id: "objects:printer", label: "printer", names: ["printer"] },
    { id: "objects:keyboard", label: "keyboard", names: ["keyboard"] },
    { id: "objects:computer_mouse", label: "computer mouse", names: ["computer_mouse"] },
    { id: "objects:trackball", label: "trackball", names: ["trackball"] },
    { id: "objects:abacus", label: "abacus", names: ["abacus"] },
    { id: "objects:film_frames", label: "film frames", names: ["film_frames"] },
    { id: "objects:label", label: "label", names: ["label"] },
    { id: "objects:linked_paperclips", label: "linked paperclips", names: ["linked_paperclips"] },
    { id: "objects:hammer_and_pick", label: "hammer and pick", names: ["hammer_and_pick"] },
    { id: "objects:crossed_swords", label: "crossed swords", names: ["crossed_swords"] },
    { id: "objects:gear", label: "gear", names: ["gear"] },
    { id: "objects:balance_scale", label: "balance scale", names: ["balance_scale"] },
    { id: "objects:white_cane", label: "white cane", names: ["white_cane"] },
    { id: "objects:broken_chain", label: "broken chain", names: ["broken_chain"] },
    { id: "objects:shovel", label: "shovel", names: ["shovel"] },
    { id: "objects:alembic", label: "alembic", names: ["alembic"] },
    { id: "objects:test_tube", label: "test tube", names: ["test_tube"] },
    { id: "objects:petri_dish", label: "petri dish", names: ["petri_dish"] },
    { id: "objects:dna", label: "dna", names: ["dna"] },

    // medical
    { id: "objects:syringe", label: "syringe", names: ["syringe"] },
    { id: "objects:drop_of_blood", label: "drop of blood", names: ["drop_of_blood"] },
    { id: "objects:pill", label: "pill", names: ["pill"] },
    { id: "objects:adhesive_bandage", label: "adhesive bandage", names: ["adhesive_bandage"] },
    { id: "objects:crutch", label: "crutch", names: ["crutch"] },
    { id: "objects:stethoscope", label: "stethoscope", names: ["stethoscope"] },
    { id: "objects:x_ray", label: "x-ray", names: ["x_ray"] },
    { id: "objects:bubbles", label: "bubbles", names: ["bubbles"] },
    { id: "objects:identification_card", label: "identification card", names: ["identification_card"] },

    // symbols
    { id: "symbols:black_flag", label: "black flag", names: ["black_flag"] },
    { id: "symbols:peace", label: "peace", names: ["peace"] },
    { id: "symbols:japan/beginner", label: "beginner", names: ["beginner"] },
    { id: "symbols:japan/here", label: "Japanese “here” button", names: ["japan_here", "japanese_here"] },
    { id: "symbols:japan/service_charge", label: "Japanese “service charge” button", names: ["japan_service_charge", "japanese_service_charge"] },
    { id: "symbols:japan/monthly_amount", label: "Japanese “monthly amount” button", names: ["japan_monthly_amount", "japanese_monthly_amount"] },
    { id: "symbols:japan/not_free_of_charge", label: "Japanese “not free of charge” button", names: ["japan_not_free_of_charge", "japanese_not_free_of_charge"] },
    { id: "symbols:japan/reserved", label: "Japanese “reserved” button", names: ["japan_reserved", "japanese_reserved"] },
    { id: "symbols:japan/bargain", label: "Japanese “bargain” button", names: ["japan_bargain", "japanese_bargain"] },
    { id: "symbols:japan/discount", label: "Japanese “discount” button", names: ["japan_discount", "japanese_discount"] },
    { id: "symbols:japan/free_of_charge", label: "Japanese “free of charge” button", names: ["japan_free_of_charge", "japanese_free_of_charge"] },
    { id: "symbols:japan/prohibited", label: "Japanese “prohibited” button", names: ["japan_prohibited", "japanese_prohibited"] },
    { id: "symbols:japan/acceptable", label: "Japanese “acceptable” button", names: ["japan_acceptable", "japanese_acceptable"] },
    { id: "symbols:japan/application", label: "Japanese “application” button", names: ["japan_application", "japanese_application"] },
    { id: "symbols:japan/passing_grade", label: "Japanese “passing grade” button", names: ["japan_passing_grade", "japanese_passing_grade"] },
    { id: "symbols:japan/vacancy", label: "Japanese “vacancy” button", names: ["japan_vacancy", "japanese_vacancy"] },
    { id: "symbols:japan/congratulations", label: "Japanese “congratulations” button", names: ["japan_congratulations", "japanese_congratulations"] },
    { id: "symbols:japan/secret", label: "Japanese “secret” button", names: ["japan_secret", "japanese_secret"] },
    { id: "symbols:japan/open_for_business", label: "Japanese “open for business” button", names: ["japan_open_for_business", "japanese_open_for_business"] },
    { id: "symbols:japan/no_vacancy", label: "Japanese “no vacancy” button", names: ["japan_no_vacancy", "japanese_no_vacancy"] },
    { id: "symbols:trident", label: "trident", names: ["trident"] },
    { id: "symbols:square_button_black", label: "square button black", names: ["square_button_black"] },
    { id: "symbols:square_button_white", label: "square button white", names: ["square_button_white"] },
    { id: "symbols:red_circle", label: "red circle", names: ["red_circle"] },
    { id: "symbols:blue_circle", label: "blue circle", names: ["blue_circle"] },
    { id: "symbols:orange_diamond", label: "orange diamond", names: ["orange_diamond"] },
    { id: "symbols:blue_diamond", label: "blue diamond", names: ["blue_diamond"] },
    { id: "symbols:small_orange_diamond", label: "small orange diamond", names: ["small_orange_diamond"] },
    { id: "symbols:small_blue_diamond", label: "small blue diamond", names: ["small_blue_diamond"] },
    { id: "symbols:up_triangle", label: "up triangle", names: ["up_triangle"] },
    { id: "symbols:down_triangle", label: "down triangle", names: ["down_triangle"] },
    { id: "symbols:up_button", label: "up button", names: ["up_button"] },
    { id: "symbols:down_button", label: "down button", names: ["down_button"] },
    { id: "symbols:left_speech", label: "left speech", names: ["left_speech"] },

    // warnings
    { id: "symbols:warning", label: "warning", names: ["warning"] },
    { id: "symbols:white_circle", label: "white circle", names: ["white_circle"] },
    { id: "symbols:black_circle", label: "black circle", names: ["black_circle"] },
    { id: "symbols:coffin", label: "coffin", names: ["coffin"] },
    { id: "symbols:urn", label: "urn", names: ["urn"] },
    { id: "symbols:soccer", label: "soccer", names: ["soccer"] },
    { id: "symbols:baseball", label: "baseball", names: ["baseball"] },
    { id: "symbols:ophiuchus", label: "ophiuchus", names: ["ophiuchus"] },
    { id: "symbols:no_entry_red", label: "no entry red", names: ["no_entry_red", "no_entry_sign"] },
    { id: "symbols:shinto_shrine", label: "shinto shrine", names: ["shinto_shrine"] },
    { id: "symbols:asterisk", label: "asterisk", names: ["asterisk"] },
    { id: "symbols:eight_pointed_star", label: "eight pointed star", names: ["eight_pointed_star"] },
    { id: "symbols:cross_mark", label: "cross mark", names: ["cross_mark"] },
    { id: "symbols:cross_square", label: "cross square", names: ["cross_square"] },
    { id: "symbols:question", label: "question", names: ["question"] },
    { id: "symbols:question_white", label: "question white", names: ["question_white"] },
    { id: "symbols:exclamation_white", label: "exclamation white", names: ["exclamation_white"] },
    { id: "symbols:exclamation", label: "exclamation", names: ["exclamation"] },
    { id: "symbols:heart_exclamation", label: "heart exclamation", names: ["heart_exclamation"] },
    { id: "symbols:heart_red", label: "heart red", names: ["heart_red"] },
    { id: "symbols:plus", label: "plus", names: ["plus"] },

    // arrows
    { id: "symbols:arrow/left", label: "left arrow", names: ["left_arrow", "arrow_left"] },
    { id: "symbols:arrow/up", label: "up arrow", names: ["up_arrow", "arrow_up"] },
    { id: "symbols:arrow/down", label: "down arrow", names: ["down_arrow", "arrow_down"] },
    { id: "symbols:arrow/right", label: "right arrow", names: ["right_arrow", "arrow_right"] },
    { id: "symbols:arrow/back", label: "back arrow", names: ["back_arrow"] },
    { id: "symbols:arrow/end", label: "end arrow", names: ["end_arrow"] },
    { id: "symbols:arrow/on", label: "on arrow", names: ["on_arrow"] },
    { id: "symbols:arrow/soon", label: "soon arrow", names: ["soon_arrow"] },
    { id: "symbols:arrow/top", label: "top arrow", names: ["top_arrow"] },
    { id: "symbols:black_large_square", label: "black large square", names: ["black_large_square"] },
    { id: "symbols:white_large_square", label: "white large square", names: ["white_large_square"] },
    { id: "symbols:circle_red", label: "circle red", names: ["circle_red"] },
    { id: "symbols:letter/a", label: "a", names: ["a", "letter_a", "regional_indicator_a", "regional_indicator_for_a"] },
    { id: "symbols:letter/b", label: "b", names: ["b", "letter_b", "regional_indicator_b", "regional_indicator_for_b"] },
    { id: "symbols:letter/c", label: "c", names: ["c", "letter_c", "regional_indicator_c", "regional_indicator_for_c"] },
    { id: "symbols:letter/d", label: "d", names: ["d", "letter_d", "regional_indicator_d", "regional_indicator_for_d"] },
    { id: "symbols:letter/e", label: "e", names: ["e", "letter_e", "regional_indicator_e", "regional_indicator_for_e"] },
    { id: "symbols:letter/f", label: "f", names: ["f", "letter_f", "regional_indicator_f", "regional_indicator_for_f"] },
    { id: "symbols:letter/g", label: "g", names: ["g", "letter_g", "regional_indicator_g", "regional_indicator_for_g"] },
    { id: "symbols:letter/h", label: "h", names: ["h", "letter_h", "regional_indicator_h", "regional_indicator_for_h"] },
    { id: "symbols:letter/i", label: "i", names: ["i", "letter_i", "regional_indicator_i", "regional_indicator_for_i"] },
    { id: "symbols:letter/j", label: "j", names: ["j", "letter_j", "regional_indicator_j", "regional_indicator_for_j"] },
    { id: "symbols:letter/k", label: "k", names: ["k", "letter_k", "regional_indicator_k", "regional_indicator_for_k"] },
    { id: "symbols:letter/l", label: "l", names: ["l", "letter_l", "regional_indicator_l", "regional_indicator_for_l"] },
    { id: "symbols:letter/m", label: "m", names: ["m", "letter_m", "regional_indicator_m", "regional_indicator_for_m"] },
    { id: "symbols:letter/n", label: "n", names: ["n", "letter_n", "regional_indicator_n", "regional_indicator_for_n"] },
    { id: "symbols:letter/o", label: "o", names: ["o", "letter_o", "regional_indicator_o", "regional_indicator_for_o"] },
    { id: "symbols:letter/p", label: "p", names: ["p", "letter_p", "regional_indicator_p", "regional_indicator_for_p"] },
    { id: "symbols:letter/q", label: "q", names: ["q", "letter_q", "regional_indicator_q", "regional_indicator_for_q"] },
    { id: "symbols:letter/r", label: "r", names: ["r", "letter_r", "regional_indicator_r", "regional_indicator_for_r"] },
    { id: "symbols:letter/s", label: "s", names: ["s", "letter_s", "regional_indicator_s", "regional_indicator_for_s"] },
    { id: "symbols:letter/t", label: "t", names: ["t", "letter_t", "regional_indicator_t", "regional_indicator_for_t"] },
    { id: "symbols:letter/u", label: "u", names: ["u", "letter_u", "regional_indicator_u", "regional_indicator_for_u"] },
    { id: "symbols:letter/v", label: "v", names: ["v", "letter_v", "regional_indicator_v", "regional_indicator_for_v"] },
    { id: "symbols:letter/w", label: "w", names: ["w", "letter_w", "regional_indicator_w", "regional_indicator_for_w"] },
    { id: "symbols:letter/x", label: "x", names: ["x", "letter_x", "regional_indicator_x", "regional_indicator_for_x"] },
    { id: "symbols:letter/y", label: "y", names: ["y", "letter_y", "regional_indicator_y", "regional_indicator_for_y"] },
    { id: "symbols:letter/z", label: "z", names: ["z", "letter_z", "regional_indicator_z", "regional_indicator_for_z"] },
    { id: "symbols:wheelchair_symbol", label: "wheelchair symbol", names: ["wheelchair_symbol"] },
    { id: "symbols:no_one_under_eighteen", label: "no one under eighteen", names: ["no_one_under_eighteen"] },
    { id: "symbols:radioactive", label: "radioactive", names: ["radioactive"] },
    { id: "symbols:biohazard", label: "biohazard", names: ["biohazard"] },
    { id: "symbols:arrow/up_right", label: "up-right arrow", names: ["arrow_up_right", "up_right_arrow"] },
    { id: "symbols:arrow/down_right", label: "down-right arrow", names: ["arrow_down_right", "down_right_arrow"] },
    { id: "symbols:arrow/down_left", label: "down-left arrow", names: ["arrow_down_left", "down_left_arrow"] },
    { id: "symbols:arrow/up_left", label: "up-left arrow", names: ["arrow_up_left", "up_left_arrow"] },
    { id: "symbols:arrow/up_down", label: "up-down arrow", names: ["arrow_up_down", "up_down_arrow"] },
    { id: "symbols:arrow/left_right", label: "left-right arrow", names: ["arrow_left_right", "left_right_arrow"] },
    { id: "symbols:arrow/right_arrow_curving_left", label: "right arrow curving left", names: ["arrow_right_arrow_curving_left", "right_arrow_curving_left"] },
    { id: "symbols:arrow/left_arrow_curving_right", label: "left arrow curving right", names: ["arrow_left_arrow_curving_right", "left_arrow_curving_right"] },
    { id: "symbols:arrow/right_arrow_curving_up", label: "right arrow curving up", names: ["arrow_right_arrow_curving_up", "right_arrow_curving_up"] },
    { id: "symbols:arrow/right_arrow_curving_down", label: "right arrow curving down", names: ["arrow_right_arrow_curving_down", "right_arrow_curving_down"] },

    // religion
    { id: "symbols:religion/atom_symbol", label: "atom symbol", names: ["religion_atom_symbol", "atom_symbol"] },
    { id: "symbols:religion/om", label: "om", names: ["religion_om", "om"] },
    { id: "symbols:religion/wheel_of_dharma", label: "wheel of dharma", names: ["religion_wheel_of_dharma", "wheel_of_dharma"] },
    { id: "symbols:religion/yin_yang", label: "yin yang", names: ["religion_yin_yang", "yin_yang"] },
    { id: "symbols:religion/orthodox_cross", label: "orthodox cross", names: ["religion_orthodox_cross", "orthodox_cross"] },
    { id: "symbols:religion/star_and_crescent", label: "star and crescent", names: ["religion_star_and_crescent", "star_and_crescent"] },
    { id: "symbols:religion/peace_symbol", label: "peace symbol", names: ["religion_peace_symbol", "peace_symbol"] },
    { id: "symbols:religion/menorah", label: "menorah", names: ["religion_menorah", "menorah"] },
    { id: "symbols:religion/dotted_six_pointed_star", label: "dotted six-pointed star", names: ["religion_dotted_six_pointed_star", "dotted_six_pointed_star"] },

    // zodiac
    { id: "symbols:zodiac/aries", label: "Aries", names: ["zodiac_aries", "aries"] },
    { id: "symbols:zodiac/taurus", label: "Taurus", names: ["zodiac_taurus", "taurus"] },
    { id: "symbols:zodiac/gemini", label: "Gemini", names: ["zodiac_gemini", "gemini"] },
    { id: "symbols:zodiac/cancer", label: "Cancer", names: ["zodiac_cancer", "cancer"] },
    { id: "symbols:zodiac/leo", label: "Leo", names: ["zodiac_leo", "leo"] },
    { id: "symbols:zodiac/virgo", label: "Virgo", names: ["zodiac_virgo", "virgo"] },
    { id: "symbols:zodiac/libra", label: "Libra", names: ["zodiac_libra", "libra"] },
    { id: "symbols:zodiac/scorpio", label: "Scorpio", names: ["zodiac_scorpio", "scorpio"] },
    { id: "symbols:zodiac/sagittarius", label: "Sagittarius", names: ["zodiac_sagittarius", "sagittarius"] },
    { id: "symbols:zodiac/capricorn", label: "Capricorn", names: ["zodiac_capricorn", "capricorn"] },
    { id: "symbols:zodiac/aquarius", label: "Aquarius", names: ["zodiac_aquarius", "aquarius"] },
    { id: "symbols:zodiac/pisces", label: "Pisces", names: ["zodiac_pisces", "pisces"] },

    // av symbols
    { id: "symbols:av/play", label: "play button", names: ["play_button", "play"] },
    { id: "symbols:av/fast_forward", label: "fast-forward button", names: ["fast_forward_button", "fast_forward"] },
    { id: "symbols:av/next_track", label: "next track button", names: ["next_track_button", "next_track"] },
    { id: "symbols:av/play_or_pause", label: "play or pause button", names: ["play_or_pause_button", "play_or_pause"] },
    { id: "symbols:av/reverse", label: "reverse button", names: ["reverse_button", "reverse"] },
    { id: "symbols:av/fast_reverse", label: "fast reverse button", names: ["fast_reverse_button", "fast_reverse"] },
    { id: "symbols:av/last_track", label: "last track button", names: ["last_track_button", "last_track"] },
    { id: "symbols:av/fast_up", label: "fast up button", names: ["fast_up_button", "fast_up"] },
    { id: "symbols:av/fast_down", label: "fast down button", names: ["fast_down_button", "fast_down"] },
    { id: "symbols:av/pause", label: "pause button", names: ["pause_button", "pause"] },
    { id: "symbols:av/stop", label: "stop button", names: ["stop_button", "stop"] },
    { id: "symbols:av/record", label: "record button", names: ["record_button", "record"] },
    { id: "symbols:av/eject", label: "eject button", names: ["eject_button", "eject"] },
    { id: "symbols:av/wireless", label: "wireless", names: ["wireless"] },

    // gender
    { id: "symbols:female_sign", label: "female sign", names: ["female_sign"] },
    { id: "symbols:male_sign", label: "male sign", names: ["male_sign"] },
    { id: "symbols:transgender_symbol", label: "transgender symbol", names: ["transgender_symbol"] },

    // math
    { id: "symbols:math/heavy_equals_sign", label: "heavy equals sign", names: ["math_heavy_equals_sign", "heavy_equals_sign"] },
    { id: "symbols:math/infinity", label: "infinity", names: ["math_infinity", "infinity"] },
    { id: "symbols:double_exclamation_mark", label: "double exclamation mark", names: ["double_exclamation_mark"] },
    { id: "symbols:exclamation_question_mark", label: "exclamation question mark", names: ["exclamation_question_mark"] },
    { id: "symbols:wavy_dash", label: "wavy dash", names: ["wavy_dash"] },
    { id: "symbols:medical_symbol", label: "medical symbol", names: ["medical_symbol"] },
    { id: "symbols:recycling_symbol", label: "recycling symbol", names: ["recycling_symbol"] },
    { id: "symbols:fleur_de_lis", label: "fleur-de-lis", names: ["fleur_de_lis"] },
    { id: "symbols:check_box_with_check", label: "check box with check", names: ["check_box_with_check"] },
    { id: "symbols:part_alternation_mark", label: "part alternation mark", names: ["part_alternation_mark"] },
    { id: "symbols:copyright", label: "copyright", names: ["copyright"] },
    { id: "symbols:registered", label: "registered", names: ["registered"] },
    { id: "symbols:trade_mark", label: "trade mark", names: ["trade_mark"] },
    { id: "symbols:splatter", label: "splatter", names: ["splatter"] },

    // keycaps
    { id: "symbols:keycap/hash", label: "keycap: #", names: ["hash", "keycap_hash", "#", "keycap_#"] },
    { id: "symbols:keycap/asterisk", label: "keycap: *", names: ["asterisk", "keycap_asterisk", "*", "keycap_*"] },
    { id: "symbols:keycap/zero", label: "keycap: 0", names: ["zero", "keycap_zero", "0", "keycap_0"] },
    { id: "symbols:keycap/one", label: "keycap: 1", names: ["one", "keycap_one", "1", "keycap_1"] },
    { id: "symbols:keycap/two", label: "keycap: 2", names: ["two", "keycap_two", "2", "keycap_2"] },
    { id: "symbols:keycap/three", label: "keycap: 3", names: ["three", "keycap_three", "3", "keycap_3"] },
    { id: "symbols:keycap/four", label: "keycap: 4", names: ["four", "keycap_four", "4", "keycap_4"] },
    { id: "symbols:keycap/five", label: "keycap: 5", names: ["five", "keycap_five", "5", "keycap_5"] },
    { id: "symbols:keycap/six", label: "keycap: 6", names: ["six", "keycap_six", "6", "keycap_6"] },
    { id: "symbols:keycap/seven", label: "keycap: 7", names: ["seven", "keycap_seven", "7", "keycap_7"] },
    { id: "symbols:keycap/eight", label: "keycap: 8", names: ["eight", "keycap_eight", "8", "keycap_8"] },
    { id: "symbols:keycap/nine", label: "keycap: 9", names: ["nine", "keycap_nine", "9", "keycap_9"] },
    { id: "symbols:keycap/ten", label: "keycap: 10", names: ["ten", "keycap_ten", "10", "keycap_10"] },

    // alphanum
    { id: "symbols:button/input_latin_uppercase", label: "input latin uppercase", names: ["input_latin_uppercase"] },
    { id: "symbols:button/input_latin_lowercase", label: "input latin lowercase", names: ["input_latin_lowercase"] },
    { id: "symbols:button/input_numbers", label: "input numbers", names: ["input_numbers"] },
    { id: "symbols:button/input_symbols", label: "input symbols", names: ["input_symbols"] },
    { id: "symbols:button/input_latin_letters", label: "input latin letters", names: ["input_latin_letters"] },
    { id: "symbols:button/a_blood_type", label: "A button (blood type)", names: ["a_blood_type", "a_button_blood_type"] },
    { id: "symbols:button/ab_blood_type", label: "AB button (blood type)", names: ["ab_blood_type", "ab_button_blood_type"] },
    { id: "symbols:button/b_blood_type", label: "B button (blood type)", names: ["b_blood_type", "b_button_blood_type"] },
    { id: "symbols:button/cl", label: "CL button", names: ["cl_button", "cl"] },
    { id: "symbols:button/cool", label: "COOL button", names: ["cool_button", "cool"] },
    { id: "symbols:button/free", label: "FREE button", names: ["free_button", "free"] },
    { id: "symbols:button/information", label: "information", names: ["information"] },
    { id: "symbols:button/id", label: "ID button", names: ["id_button", "id"] },
    { id: "symbols:button/circled_m", label: "circled M", names: ["circled_m"] },
    { id: "symbols:button/new", label: "NEW button", names: ["new_button", "new"] },
    { id: "symbols:button/ng", label: "NG button", names: ["ng_button", "ng"] },
    { id: "symbols:button/o_blood_type", label: "O button (blood type)", names: ["o_blood_type", "o_button_blood_type"] },
    { id: "symbols:button/ok", label: "OK button", names: ["ok_button", "ok"] },
    { id: "symbols:button/p", label: "P button", names: ["p_button", "p"] },
    { id: "symbols:button/sos", label: "SOS button", names: ["sos_button", "sos"] },
    { id: "symbols:button/up", label: "UP! button", names: ["up_button", "up"] },
    { id: "symbols:button/vs", label: "VS button", names: ["vs_button", "vs"] },

    // geometric
    { id: "symbols:shape/orange_circle", label: "orange circle", names: ["shape_orange_circle", "orange_circle"] },
    { id: "symbols:shape/yellow_circle", label: "yellow circle", names: ["shape_yellow_circle", "yellow_circle"] },
    { id: "symbols:shape/green_circle", label: "green circle", names: ["shape_green_circle", "green_circle"] },
    { id: "symbols:shape/purple_circle", label: "purple circle", names: ["shape_purple_circle", "purple_circle"] },
    { id: "symbols:shape/brown_circle", label: "brown circle", names: ["shape_brown_circle", "brown_circle"] },
    { id: "symbols:shape/red_square", label: "red square", names: ["shape_red_square", "red_square"] },
    { id: "symbols:shape/orange_square", label: "orange square", names: ["shape_orange_square", "orange_square"] },
    { id: "symbols:shape/yellow_square", label: "yellow square", names: ["shape_yellow_square", "yellow_square"] },
    { id: "symbols:shape/green_square", label: "green square", names: ["shape_green_square", "green_square"] },
    { id: "symbols:shape/blue_square", label: "blue square", names: ["shape_blue_square", "blue_square"] },
    { id: "symbols:shape/purple_square", label: "purple square", names: ["shape_purple_square", "purple_square"] },
    { id: "symbols:shape/brown_square", label: "brown square", names: ["shape_brown_square", "brown_square"] },
    { id: "symbols:shape/black_medium_square", label: "black medium square", names: ["shape_black_medium_square", "black_medium_square"] },
    { id: "symbols:shape/white_medium_square", label: "white medium square", names: ["shape_white_medium_square", "white_medium_square"] },
    { id: "symbols:shape/black_medium_small_square", label: "black medium-small square", names: ["shape_black_medium_small_square", "black_medium_small_square"] },
    { id: "symbols:shape/white_medium_small_square", label: "white medium-small square", names: ["shape_white_medium_small_square", "white_medium_small_square"] },
    { id: "symbols:shape/black_small_square", label: "black small square", names: ["shape_black_small_square", "black_small_square"] },
    { id: "symbols:shape/white_small_square", label: "white small square", names: ["shape_white_small_square", "white_small_square"] },
    { id: "symbols:shape/diamond_with_a_dot", label: "diamond with a dot", names: ["shape_diamond_with_a_dot", "diamond_with_a_dot"] },
    

    // flags
    { id: "flags:white", label: "white flag", names: ["white_flag", "flag_white", "surrender"] },
    { id: "flags:checkered", label: "flag checkered", names: ["flag_checkered"] },
    { id: "flags:black", label: "flag black", names: ["flag_black"] },
    { id: "flags:peace", label: "flag peace", names: ["flag_peace"] },
    { id: "flags:triangular", label: "flag triangular", names: ["flag_triangular"] },

    // country flags
    { id: "flags:country/ac", label: "Ascension Island flag", names: ["flag_ac"] },
    { id: "flags:country/ad", label: "Andorra flag", names: ["flag_ad"] },
    { id: "flags:country/ae", label: "United Arab Emirates flag", names: ["flag_ae"] },
    { id: "flags:country/af", label: "Afghanistan flag", names: ["flag_af"] },
    { id: "flags:country/ag", label: "Antigua & Barbuda flag", names: ["flag_ag"] },
    { id: "flags:country/ai", label: "Anguilla flag", names: ["flag_ai"] },
    { id: "flags:country/al", label: "Albania flag", names: ["flag_al"] },
    { id: "flags:country/am", label: "Armenia flag", names: ["flag_am"] },
    { id: "flags:country/ao", label: "Angola flag", names: ["flag_ao"] },
    { id: "flags:country/aq", label: "Antarctica flag", names: ["flag_aq"] },
    { id: "flags:country/ar", label: "Argentina flag", names: ["flag_ar"] },
    { id: "flags:country/as", label: "American Samoa flag", names: ["flag_as"] },
    { id: "flags:country/at", label: "Austria flag", names: ["flag_at"] },
    { id: "flags:country/au", label: "Australia flag", names: ["flag_au"] },
    { id: "flags:country/aw", label: "Aruba flag", names: ["flag_aw"] },
    { id: "flags:country/ax", label: "Åland Islands flag", names: ["flag_ax"] },
    { id: "flags:country/az", label: "Azerbaijan flag", names: ["flag_az"] },
    { id: "flags:country/ba", label: "Bosnia & Herzegovina flag", names: ["flag_ba"] },
    { id: "flags:country/bb", label: "Barbados flag", names: ["flag_bb"] },
    { id: "flags:country/bd", label: "Bangladesh flag", names: ["flag_bd"] },
    { id: "flags:country/be", label: "Belgium flag", names: ["flag_be"] },
    { id: "flags:country/bf", label: "Burkina Faso flag", names: ["flag_bf"] },
    { id: "flags:country/bg", label: "Bulgaria flag", names: ["flag_bg"] },
    { id: "flags:country/bh", label: "Bahrain flag", names: ["flag_bh"] },
    { id: "flags:country/bi", label: "Burundi flag", names: ["flag_bi"] },
    { id: "flags:country/bj", label: "Benin flag", names: ["flag_bj"] },
    { id: "flags:country/bl", label: "St. Barthélemy flag", names: ["flag_bl"] },
    { id: "flags:country/bm", label: "Bermuda flag", names: ["flag_bm"] },
    { id: "flags:country/bn", label: "Brunei flag", names: ["flag_bn"] },
    { id: "flags:country/bo", label: "Bolivia flag", names: ["flag_bo"] },
    { id: "flags:country/bq", label: "Caribbean Netherlands flag", names: ["flag_bq"] },
    { id: "flags:country/br", label: "Brazil flag", names: ["flag_br"] },
    { id: "flags:country/bs", label: "Bahamas flag", names: ["flag_bs"] },
    { id: "flags:country/bt", label: "Bhutan flag", names: ["flag_bt"] },
    { id: "flags:country/bv", label: "Bouvet Island flag", names: ["flag_bv"] },
    { id: "flags:country/bw", label: "Botswana flag", names: ["flag_bw"] },
    { id: "flags:country/by", label: "Belarus flag", names: ["flag_by"] },
    { id: "flags:country/bz", label: "Belize flag", names: ["flag_bz"] },
    { id: "flags:country/ca", label: "Canada flag", names: ["flag_ca"] },
    { id: "flags:country/cc", label: "Cocos (Keeling) Islands flag", names: ["flag_cc"] },
    { id: "flags:country/cd", label: "Congo - Kinshasa flag", names: ["flag_cd"] },
    { id: "flags:country/cf", label: "Central African Republic flag", names: ["flag_cf"] },
    { id: "flags:country/cg", label: "Congo - Brazzaville flag", names: ["flag_cg"] },
    { id: "flags:country/ch", label: "Switzerland flag", names: ["flag_ch"] },
    { id: "flags:country/ci", label: "Côte d’Ivoire flag", names: ["flag_ci"] },
    { id: "flags:country/ck", label: "Cook Islands flag", names: ["flag_ck"] },
    { id: "flags:country/cl", label: "Chile flag", names: ["flag_cl"] },
    { id: "flags:country/cm", label: "Cameroon flag", names: ["flag_cm"] },
    { id: "flags:country/cn", label: "China flag", names: ["flag_cn"] },
    { id: "flags:country/co", label: "Colombia flag", names: ["flag_co"] },
    { id: "flags:country/cp", label: "Clipperton Island flag", names: ["flag_cp"] },
    { id: "flags:country/cr", label: "Costa Rica flag", names: ["flag_cr"] },
    { id: "flags:country/cu", label: "Cuba flag", names: ["flag_cu"] },
    { id: "flags:country/cv", label: "Cape Verde flag", names: ["flag_cv"] },
    { id: "flags:country/cw", label: "Curaçao flag", names: ["flag_cw"] },
    { id: "flags:country/cx", label: "Christmas Island flag", names: ["flag_cx"] },
    { id: "flags:country/cy", label: "Cyprus flag", names: ["flag_cy"] },
    { id: "flags:country/cz", label: "Czechia flag", names: ["flag_cz"] },
    { id: "flags:country/de", label: "Germany flag", names: ["flag_de"] },
    { id: "flags:country/dg", label: "Diego Garcia flag", names: ["flag_dg"] },
    { id: "flags:country/dj", label: "Djibouti flag", names: ["flag_dj"] },
    { id: "flags:country/dk", label: "Denmark flag", names: ["flag_dk"] },
    { id: "flags:country/dm", label: "Dominica flag", names: ["flag_dm"] },
    { id: "flags:country/do", label: "Dominican Republic flag", names: ["flag_do"] },
    { id: "flags:country/dz", label: "Algeria flag", names: ["flag_dz"] },
    { id: "flags:country/ea", label: "Ceuta & Melilla flag", names: ["flag_ea"] },
    { id: "flags:country/ec", label: "Ecuador flag", names: ["flag_ec"] },
    { id: "flags:country/ee", label: "Estonia flag", names: ["flag_ee"] },
    { id: "flags:country/eg", label: "Egypt flag", names: ["flag_eg"] },
    { id: "flags:country/eh", label: "Western Sahara flag", names: ["flag_eh"] },
    { id: "flags:country/er", label: "Eritrea flag", names: ["flag_er"] },
    { id: "flags:country/es", label: "Spain flag", names: ["flag_es"] },
    { id: "flags:country/et", label: "Ethiopia flag", names: ["flag_et"] },
    { id: "flags:country/eu", label: "European Union flag", names: ["flag_eu"] },
    { id: "flags:country/fi", label: "Finland flag", names: ["flag_fi"] },
    { id: "flags:country/fj", label: "Fiji flag", names: ["flag_fj"] },
    { id: "flags:country/fk", label: "Falkland Islands flag", names: ["flag_fk"] },
    { id: "flags:country/fm", label: "Micronesia flag", names: ["flag_fm"] },
    { id: "flags:country/fo", label: "Faroe Islands flag", names: ["flag_fo"] },
    { id: "flags:country/fr", label: "France flag", names: ["flag_fr"] },
    { id: "flags:country/ga", label: "Gabon flag", names: ["flag_ga"] },
    { id: "flags:country/gb", label: "United Kingdom flag", names: ["flag_gb"] },
    { id: "flags:country/gd", label: "Grenada flag", names: ["flag_gd"] },
    { id: "flags:country/ge", label: "Georgia flag", names: ["flag_ge"] },
    { id: "flags:country/gf", label: "French Guiana flag", names: ["flag_gf"] },
    { id: "flags:country/gg", label: "Guernsey flag", names: ["flag_gg"] },
    { id: "flags:country/gh", label: "Ghana flag", names: ["flag_gh"] },
    { id: "flags:country/gi", label: "Gibraltar flag", names: ["flag_gi"] },
    { id: "flags:country/gl", label: "Greenland flag", names: ["flag_gl"] },
    { id: "flags:country/gm", label: "Gambia flag", names: ["flag_gm"] },
    { id: "flags:country/gn", label: "Guinea flag", names: ["flag_gn"] },
    { id: "flags:country/gp", label: "Guadeloupe flag", names: ["flag_gp"] },
    { id: "flags:country/gq", label: "Equatorial Guinea flag", names: ["flag_gq"] },
    { id: "flags:country/gr", label: "Greece flag", names: ["flag_gr"] },
    { id: "flags:country/gs", label: "South Georgia & South Sandwich Islands flag", names: ["flag_gs"] },
    { id: "flags:country/gt", label: "Guatemala flag", names: ["flag_gt"] },
    { id: "flags:country/gu", label: "Guam flag", names: ["flag_gu"] },
    { id: "flags:country/gw", label: "Guinea-Bissau flag", names: ["flag_gw"] },
    { id: "flags:country/gy", label: "Guyana flag", names: ["flag_gy"] },
    { id: "flags:country/hk", label: "Hong Kong SAR China flag", names: ["flag_hk"] },
    { id: "flags:country/hm", label: "Heard & McDonald Islands flag", names: ["flag_hm"] },
    { id: "flags:country/hn", label: "Honduras flag", names: ["flag_hn"] },
    { id: "flags:country/hr", label: "Croatia flag", names: ["flag_hr"] },
    { id: "flags:country/ht", label: "Haiti flag", names: ["flag_ht"] },
    { id: "flags:country/hu", label: "Hungary flag", names: ["flag_hu"] },
    { id: "flags:country/ic", label: "Canary Islands flag", names: ["flag_ic"] },
    { id: "flags:country/id", label: "Indonesia flag", names: ["flag_id"] },
    { id: "flags:country/ie", label: "Ireland flag", names: ["flag_ie"] },
    { id: "flags:country/il", label: "Israel flag", names: ["flag_il"] },
    { id: "flags:country/im", label: "Isle of Man flag", names: ["flag_im"] },
    { id: "flags:country/in", label: "India flag", names: ["flag_in"] },
    { id: "flags:country/io", label: "British Indian Ocean Territory flag", names: ["flag_io"] },
    { id: "flags:country/iq", label: "Iraq flag", names: ["flag_iq"] },
    { id: "flags:country/ir", label: "Iran flag", names: ["flag_ir"] },
    { id: "flags:country/is", label: "Iceland flag", names: ["flag_is"] },
    { id: "flags:country/it", label: "Italy flag", names: ["flag_it"] },
    { id: "flags:country/je", label: "Jersey flag", names: ["flag_je"] },
    { id: "flags:country/jm", label: "Jamaica flag", names: ["flag_jm"] },
    { id: "flags:country/jo", label: "Jordan flag", names: ["flag_jo"] },
    { id: "flags:country/jp", label: "Japan flag", names: ["flag_jp"] },
    { id: "flags:country/ke", label: "Kenya flag", names: ["flag_ke"] },
    { id: "flags:country/kg", label: "Kyrgyzstan flag", names: ["flag_kg"] },
    { id: "flags:country/kh", label: "Cambodia flag", names: ["flag_kh"] },
    { id: "flags:country/ki", label: "Kiribati flag", names: ["flag_ki"] },
    { id: "flags:country/km", label: "Comoros flag", names: ["flag_km"] },
    { id: "flags:country/kn", label: "St. Kitts & Nevis flag", names: ["flag_kn"] },
    { id: "flags:country/kp", label: "North Korea flag", names: ["flag_kp"] },
    { id: "flags:country/kr", label: "South Korea flag", names: ["flag_kr"] },
    { id: "flags:country/kw", label: "Kuwait flag", names: ["flag_kw"] },
    { id: "flags:country/ky", label: "Cayman Islands flag", names: ["flag_ky"] },
    { id: "flags:country/kz", label: "Kazakhstan flag", names: ["flag_kz"] },
    { id: "flags:country/la", label: "Laos flag", names: ["flag_la"] },
    { id: "flags:country/lb", label: "Lebanon flag", names: ["flag_lb"] },
    { id: "flags:country/lc", label: "St. Lucia flag", names: ["flag_lc"] },
    { id: "flags:country/li", label: "Liechtenstein flag", names: ["flag_li"] },
    { id: "flags:country/lk", label: "Sri Lanka flag", names: ["flag_lk"] },
    { id: "flags:country/lr", label: "Liberia flag", names: ["flag_lr"] },
    { id: "flags:country/ls", label: "Lesotho flag", names: ["flag_ls"] },
    { id: "flags:country/lt", label: "Lithuania flag", names: ["flag_lt"] },
    { id: "flags:country/lu", label: "Luxembourg flag", names: ["flag_lu"] },
    { id: "flags:country/lv", label: "Latvia flag", names: ["flag_lv"] },
    { id: "flags:country/ly", label: "Libya flag", names: ["flag_ly"] },
    { id: "flags:country/ma", label: "Morocco flag", names: ["flag_ma"] },
    { id: "flags:country/mc", label: "Monaco flag", names: ["flag_mc"] },
    { id: "flags:country/md", label: "Moldova flag", names: ["flag_md"] },
    { id: "flags:country/me", label: "Montenegro flag", names: ["flag_me"] },
    { id: "flags:country/mf", label: "St. Martin flag", names: ["flag_mf"] },
    { id: "flags:country/mg", label: "Madagascar flag", names: ["flag_mg"] },
    { id: "flags:country/mh", label: "Marshall Islands flag", names: ["flag_mh"] },
    { id: "flags:country/mk", label: "North Macedonia flag", names: ["flag_mk"] },
    { id: "flags:country/ml", label: "Mali flag", names: ["flag_ml"] },
    { id: "flags:country/mm", label: "Myanmar (Burma) flag", names: ["flag_mm"] },
    { id: "flags:country/mn", label: "Mongolia flag", names: ["flag_mn"] },
    { id: "flags:country/mo", label: "Macao SAR China flag", names: ["flag_mo"] },
    { id: "flags:country/mp", label: "Northern Mariana Islands flag", names: ["flag_mp"] },
    { id: "flags:country/mq", label: "Martinique flag", names: ["flag_mq"] },
    { id: "flags:country/mr", label: "Mauritania flag", names: ["flag_mr"] },
    { id: "flags:country/ms", label: "Montserrat flag", names: ["flag_ms"] },
    { id: "flags:country/mt", label: "Malta flag", names: ["flag_mt"] },
    { id: "flags:country/mu", label: "Mauritius flag", names: ["flag_mu"] },
    { id: "flags:country/mv", label: "Maldives flag", names: ["flag_mv"] },
    { id: "flags:country/mw", label: "Malawi flag", names: ["flag_mw"] },
    { id: "flags:country/mx", label: "Mexico flag", names: ["flag_mx"] },
    { id: "flags:country/my", label: "Malaysia flag", names: ["flag_my"] },
    { id: "flags:country/mz", label: "Mozambique flag", names: ["flag_mz"] },
    { id: "flags:country/na", label: "Namibia flag", names: ["flag_na"] },
    { id: "flags:country/nc", label: "New Caledonia flag", names: ["flag_nc"] },
    { id: "flags:country/ne", label: "Niger flag", names: ["flag_ne"] },
    { id: "flags:country/nf", label: "Norfolk Island flag", names: ["flag_nf"] },
    { id: "flags:country/ng", label: "Nigeria flag", names: ["flag_ng"] },
    { id: "flags:country/ni", label: "Nicaragua flag", names: ["flag_ni"] },
    { id: "flags:country/nl", label: "Netherlands flag", names: ["flag_nl"] },
    { id: "flags:country/no", label: "Norway flag", names: ["flag_no"] },
    { id: "flags:country/np", label: "Nepal flag", names: ["flag_np"] },
    { id: "flags:country/nr", label: "Nauru flag", names: ["flag_nr"] },
    { id: "flags:country/nu", label: "Niue flag", names: ["flag_nu"] },
    { id: "flags:country/nz", label: "New Zealand flag", names: ["flag_nz"] },
    { id: "flags:country/om", label: "Oman flag", names: ["flag_om"] },
    { id: "flags:country/pa", label: "Panama flag", names: ["flag_pa"] },
    { id: "flags:country/pe", label: "Peru flag", names: ["flag_pe"] },
    { id: "flags:country/pf", label: "French Polynesia flag", names: ["flag_pf"] },
    { id: "flags:country/pg", label: "Papua New Guinea flag", names: ["flag_pg"] },
    { id: "flags:country/ph", label: "Philippines flag", names: ["flag_ph"] },
    { id: "flags:country/pk", label: "Pakistan flag", names: ["flag_pk"] },
    { id: "flags:country/pl", label: "Poland flag", names: ["flag_pl"] },
    { id: "flags:country/pm", label: "St. Pierre & Miquelon flag", names: ["flag_pm"] },
    { id: "flags:country/pn", label: "Pitcairn Islands flag", names: ["flag_pn"] },
    { id: "flags:country/pr", label: "Puerto Rico flag", names: ["flag_pr"] },
    { id: "flags:country/ps", label: "Palestinian Territories flag", names: ["flag_ps"] },
    { id: "flags:country/pt", label: "Portugal flag", names: ["flag_pt"] },
    { id: "flags:country/pw", label: "Palau flag", names: ["flag_pw"] },
    { id: "flags:country/py", label: "Paraguay flag", names: ["flag_py"] },
    { id: "flags:country/qa", label: "Qatar flag", names: ["flag_qa"] },
    { id: "flags:country/re", label: "Réunion flag", names: ["flag_re"] },
    { id: "flags:country/ro", label: "Romania flag", names: ["flag_ro"] },
    { id: "flags:country/rs", label: "Serbia flag", names: ["flag_rs"] },
    { id: "flags:country/ru", label: "Russia flag", names: ["flag_ru"] },
    { id: "flags:country/rw", label: "Rwanda flag", names: ["flag_rw"] },
    { id: "flags:country/sa", label: "Saudi Arabia flag", names: ["flag_sa"] },
    { id: "flags:country/sb", label: "Solomon Islands flag", names: ["flag_sb"] },
    { id: "flags:country/sc", label: "Seychelles flag", names: ["flag_sc"] },
    { id: "flags:country/sd", label: "Sudan flag", names: ["flag_sd"] },
    { id: "flags:country/se", label: "Sweden flag", names: ["flag_se"] },
    { id: "flags:country/sg", label: "Singapore flag", names: ["flag_sg"] },
    { id: "flags:country/sh", label: "St. Helena flag", names: ["flag_sh"] },
    { id: "flags:country/si", label: "Slovenia flag", names: ["flag_si"] },
    { id: "flags:country/sj", label: "Svalbard & Jan Mayen flag", names: ["flag_sj"] },
    { id: "flags:country/sk", label: "Slovakia flag", names: ["flag_sk"] },
    { id: "flags:country/sl", label: "Sierra Leone flag", names: ["flag_sl"] },
    { id: "flags:country/sm", label: "San Marino flag", names: ["flag_sm"] },
    { id: "flags:country/sn", label: "Senegal flag", names: ["flag_sn"] },
    { id: "flags:country/so", label: "Somalia flag", names: ["flag_so"] },
    { id: "flags:country/sr", label: "Suriname flag", names: ["flag_sr"] },
    { id: "flags:country/ss", label: "South Sudan flag", names: ["flag_ss"] },
    { id: "flags:country/st", label: "São Tomé & Príncipe flag", names: ["flag_st"] },
    { id: "flags:country/sv", label: "El Salvador flag", names: ["flag_sv"] },
    { id: "flags:country/sx", label: "Sint Maarten flag", names: ["flag_sx"] },
    { id: "flags:country/sy", label: "Syria flag", names: ["flag_sy"] },
    { id: "flags:country/sz", label: "Eswatini flag", names: ["flag_sz"] },
    { id: "flags:country/ta", label: "Tristan da Cunha flag", names: ["flag_ta"] },
    { id: "flags:country/tc", label: "Turks & Caicos Islands flag", names: ["flag_tc"] },
    { id: "flags:country/td", label: "Chad flag", names: ["flag_td"] },
    { id: "flags:country/tf", label: "French Southern Territories flag", names: ["flag_tf"] },
    { id: "flags:country/tg", label: "Togo flag", names: ["flag_tg"] },
    { id: "flags:country/th", label: "Thailand flag", names: ["flag_th"] },
    { id: "flags:country/tj", label: "Tajikistan flag", names: ["flag_tj"] },
    { id: "flags:country/tk", label: "Tokelau flag", names: ["flag_tk"] },
    { id: "flags:country/tl", label: "Timor-Leste flag", names: ["flag_tl"] },
    { id: "flags:country/tm", label: "Turkmenistan flag", names: ["flag_tm"] },
    { id: "flags:country/tn", label: "Tunisia flag", names: ["flag_tn"] },
    { id: "flags:country/to", label: "Tonga flag", names: ["flag_to"] },
    { id: "flags:country/tr", label: "Türkiye flag", names: ["flag_tr"] },
    { id: "flags:country/tt", label: "Trinidad & Tobago flag", names: ["flag_tt"] },
    { id: "flags:country/tv", label: "Tuvalu flag", names: ["flag_tv"] },
    { id: "flags:country/tw", label: "Taiwan flag", names: ["flag_tw"] },
    { id: "flags:country/tz", label: "Tanzania flag", names: ["flag_tz"] },
    { id: "flags:country/ua", label: "Ukraine flag", names: ["flag_ua"] },
    { id: "flags:country/ug", label: "Uganda flag", names: ["flag_ug"] },
    { id: "flags:country/um", label: "U.S. Outlying Islands flag", names: ["flag_um"] },
    { id: "flags:country/un", label: "United Nations flag", names: ["flag_un"] },
    { id: "flags:country/us", label: "United States flag", names: ["flag_us"] },
    { id: "flags:country/uy", label: "Uruguay flag", names: ["flag_uy"] },
    { id: "flags:country/uz", label: "Uzbekistan flag", names: ["flag_uz"] },
    { id: "flags:country/va", label: "Vatican City flag", names: ["flag_va"] },
    { id: "flags:country/vc", label: "St. Vincent & Grenadines flag", names: ["flag_vc"] },
    { id: "flags:country/ve", label: "Venezuela flag", names: ["flag_ve"] },
    { id: "flags:country/vg", label: "British Virgin Islands flag", names: ["flag_vg"] },
    { id: "flags:country/vi", label: "U.S. Virgin Islands flag", names: ["flag_vi"] },
    { id: "flags:country/vn", label: "Vietnam flag", names: ["flag_vn"] },
    { id: "flags:country/vu", label: "Vanuatu flag", names: ["flag_vu"] },
    { id: "flags:country/wf", label: "Wallis & Futuna flag", names: ["flag_wf"] },
    { id: "flags:country/ws", label: "Samoa flag", names: ["flag_ws"] },
    { id: "flags:country/xk", label: "Kosovo flag", names: ["flag_xk"] },
    { id: "flags:country/ye", label: "Yemen flag", names: ["flag_ye"] },
    { id: "flags:country/yt", label: "Mayotte flag", names: ["flag_yt"] },
    { id: "flags:country/za", label: "South Africa flag", names: ["flag_za"] },
    { id: "flags:country/zm", label: "Zambia flag", names: ["flag_zm"] },
    { id: "flags:country/zw", label: "Zimbabwe flag", names: ["flag_zw"] },

    // subdivision flags
    { id: "flags:subdivision/gb_eng", label: "England flag", names: ["flag_gb_eng", "england"] },
    { id: "flags:subdivision/gb_sct", label: "Scotland flag", names: ["flag_gb_sct", "scotland"] },
    { id: "flags:subdivision/gb_wls", label: "Wales flag", names: ["flag_gb_wls", "wales"] },
    

    // pride flags
    { id: "flags:pride/rainbow", label: "lgbt flag", names: ["lgbt", "rainbow_flag", "pride", "pride_flag"] },
    { id: "flags:pride/pride", label: "lgbtqia flag", names: ["lgbtqia", "pride_full", "full_pride_flag"] },
    

    // gender identity pride flags
    { id: "flags:pride/trans", label: "transgender flag", names: ["trans", "trans_flag", "transgender", "transgender_flag"] },
    { id: "flags:pride/nonbinary", label: "enby flag", names: ["enby", "enby_flag", "non_binary", "nonbinary_flag", "non_binary_flag"] },
    { id: "flags:pride/genderfluid", label: "genderfluid flag", names: ["genderfluid", "genderfluid_flag"] },
    { id: "flags:pride/agender", label: "agender flag", names: ["agender", "agender_flag"] },
    { id: "flags:pride/mtf", label: "transfem flag", names: ["trans_mtf_flag", "transfeminine", "transfem", "transfeminine_flag", "transfem_flag"] },
    { id: "flags:pride/ftm", label: "transmasc flag", names: ["trans_ftm_flag", "transmasculine", "transmasc", "transmasculine_flag", "transmasc_flag"] },

    // sexual orientation pride flags
    { id: "flags:pride/lesbian", label: "lesbian flag", names: ["lesbian", "lesbian_flag"] },
    { id: "flags:pride/bisexual", label: "bisexual flag", names: ["bisexual", "bisexual_flag", "bi", "bi_flag"] },
    { id: "flags:pride/pansexual", label: "pansexual flag", names: [ "pansexual", "pan", "pansexual_flag", "pan_flag" ] },
    { id: "flags:pride/asexual", label: "asexual flag", names: ["asexual", "asexual_flag", "ace_flag", "ace"] },
    { id: "flags:pride/aromantic", label: "aromantic flag", names: ["aromantic", "aro_flag", "aro"] },
    { id: "flags:pride/aromantic_asexual", label: "aromantic asexual flag", names: ["aromantic_asexual", "aroace_flag", "aroace"] },
    { id: "flags:pride/grayromantic", label: "gray romantic flag", names: ["grayromantic", "grayromantic_flag"] },
    { id: "flags:pirate_flag", label: "pirate flag", names: ["pirate_flag"] },
    { id: "flags:country/cq", label: "flag: Sark", names: ["country_cq", "flag_sark"] },
    { id: "flags:subdivision/england", label: "flag: England", names: ["subdivision_england", "flag_england"] },

    // system
    { id: "meta:control/char", label: "control character", names: [ "char" ]},
]

